var map = {
	"./3_4_Sit-Up/0.jpg": 87680,
	"./3_4_Sit-Up/1.jpg": 43261,
	"./90_90_Hamstring/0.jpg": 392,
	"./90_90_Hamstring/1.jpg": 62757,
	"./Ab_Crunch_Machine/0.jpg": 70328,
	"./Ab_Crunch_Machine/1.jpg": 78197,
	"./Ab_Roller/0.jpg": 45349,
	"./Ab_Roller/1.jpg": 1832,
	"./Adductor/0.jpg": 2303,
	"./Adductor/1.jpg": 82306,
	"./Adductor_Groin/0.jpg": 87669,
	"./Adductor_Groin/1.jpg": 42840,
	"./Advanced_Kettlebell_Windmill/0.jpg": 73433,
	"./Advanced_Kettlebell_Windmill/1.jpg": 2908,
	"./Air_Bike/0.jpg": 96975,
	"./Air_Bike/1.jpg": 40946,
	"./All_Fours_Quad_Stretch/0.jpg": 6022,
	"./All_Fours_Quad_Stretch/1.jpg": 96131,
	"./Alternate_Hammer_Curl/0.jpg": 53873,
	"./Alternate_Hammer_Curl/1.jpg": 82068,
	"./Alternate_Heel_Touchers/0.jpg": 41272,
	"./Alternate_Heel_Touchers/1.jpg": 45589,
	"./Alternate_Incline_Dumbbell_Curl/0.jpg": 91745,
	"./Alternate_Incline_Dumbbell_Curl/1.jpg": 97348,
	"./Alternate_Leg_Diagonal_Bound/0.jpg": 94345,
	"./Alternate_Leg_Diagonal_Bound/1.jpg": 96556,
	"./Alternating_Cable_Shoulder_Press/0.jpg": 79571,
	"./Alternating_Cable_Shoulder_Press/1.jpg": 93110,
	"./Alternating_Deltoid_Raise/0.jpg": 79513,
	"./Alternating_Deltoid_Raise/1.jpg": 8988,
	"./Alternating_Floor_Press/0.jpg": 1917,
	"./Alternating_Floor_Press/1.jpg": 50784,
	"./Alternating_Hang_Clean/0.jpg": 44699,
	"./Alternating_Hang_Clean/1.jpg": 89918,
	"./Alternating_Kettlebell_Press/0.jpg": 81731,
	"./Alternating_Kettlebell_Press/1.jpg": 22246,
	"./Alternating_Kettlebell_Row/0.jpg": 74742,
	"./Alternating_Kettlebell_Row/1.jpg": 61203,
	"./Alternating_Renegade_Row/0.jpg": 65717,
	"./Alternating_Renegade_Row/1.jpg": 45048,
	"./Ankle_Circles/0.jpg": 45090,
	"./Ankle_Circles/1.jpg": 81439,
	"./Ankle_On_The_Knee/0.jpg": 69242,
	"./Ankle_On_The_Knee/1.jpg": 63703,
	"./Anterior_Tibialis-SMR/0.jpg": 56766,
	"./Anterior_Tibialis-SMR/1.jpg": 93275,
	"./Anti-Gravity_Press/0.jpg": 13538,
	"./Anti-Gravity_Press/1.jpg": 5247,
	"./Arm_Circles/0.jpg": 2145,
	"./Arm_Circles/1.jpg": 24100,
	"./Arnold_Dumbbell_Press/0.jpg": 10749,
	"./Arnold_Dumbbell_Press/1.jpg": 71520,
	"./Around_The_Worlds/0.jpg": 88804,
	"./Around_The_Worlds/1.jpg": 66849,
	"./Atlas_Stone_Trainer/0.jpg": 98484,
	"./Atlas_Stone_Trainer/1.jpg": 12209,
	"./Atlas_Stones/0.jpg": 47349,
	"./Atlas_Stones/1.jpg": 43032,
	"./Axle_Deadlift/0.jpg": 85889,
	"./Axle_Deadlift/1.jpg": 95940,
	"./Back_Flyes_-_With_Bands/0.jpg": 9966,
	"./Back_Flyes_-_With_Bands/1.jpg": 89451,
	"./Backward_Drag/0.jpg": 91505,
	"./Backward_Drag/1.jpg": 19700,
	"./Backward_Medicine_Ball_Throw/0.jpg": 90712,
	"./Backward_Medicine_Ball_Throw/1.jpg": 98581,
	"./Balance_Board/0.jpg": 49848,
	"./Balance_Board/1.jpg": 57109,
	"./Ball_Leg_Curl/0.jpg": 56274,
	"./Ball_Leg_Curl/1.jpg": 28655,
	"./Band_Assisted_Pull-Up/0.jpg": 907,
	"./Band_Assisted_Pull-Up/1.jpg": 22862,
	"./Band_Good_Morning/0.jpg": 56527,
	"./Band_Good_Morning/1.jpg": 84146,
	"./Band_Good_Morning_Pull_Through/0.jpg": 90141,
	"./Band_Good_Morning_Pull_Through/1.jpg": 64576,
	"./Band_Hip_Adductions/0.jpg": 55773,
	"./Band_Hip_Adductions/1.jpg": 20992,
	"./Band_Pull_Apart/0.jpg": 94351,
	"./Band_Pull_Apart/1.jpg": 17970,
	"./Band_Skull_Crusher/0.jpg": 55069,
	"./Band_Skull_Crusher/1.jpg": 3936,
	"./Barbell_Ab_Rollout/0.jpg": 41175,
	"./Barbell_Ab_Rollout/1.jpg": 77338,
	"./Barbell_Ab_Rollout_-_On_Knees/0.jpg": 51288,
	"./Barbell_Ab_Rollout_-_On_Knees/1.jpg": 55605,
	"./Barbell_Bench_Press_-_Medium_Grip/0.jpg": 69495,
	"./Barbell_Bench_Press_-_Medium_Grip/1.jpg": 22010,
	"./Barbell_Curl/0.jpg": 47914,
	"./Barbell_Curl/1.jpg": 70567,
	"./Barbell_Curls_Lying_Against_An_Incline/0.jpg": 49288,
	"./Barbell_Curls_Lying_Against_An_Incline/1.jpg": 95301,
	"./Barbell_Deadlift/0.jpg": 44201,
	"./Barbell_Deadlift/1.jpg": 82476,
	"./Barbell_Full_Squat/0.jpg": 43856,
	"./Barbell_Full_Squat/1.jpg": 12429,
	"./Barbell_Glute_Bridge/0.jpg": 35073,
	"./Barbell_Glute_Bridge/1.jpg": 45124,
	"./Barbell_Guillotine_Bench_Press/0.jpg": 4921,
	"./Barbell_Guillotine_Bench_Press/1.jpg": 91196,
	"./Barbell_Hack_Squat/0.jpg": 49624,
	"./Barbell_Hack_Squat/1.jpg": 53941,
	"./Barbell_Hip_Thrust/0.jpg": 28276,
	"./Barbell_Hip_Thrust/1.jpg": 6801,
	"./Barbell_Incline_Bench_Press_-_Medium_Grip/0.jpg": 74636,
	"./Barbell_Incline_Bench_Press_-_Medium_Grip/1.jpg": 46249,
	"./Barbell_Incline_Shoulder_Raise/0.jpg": 69860,
	"./Barbell_Incline_Shoulder_Raise/1.jpg": 47905,
	"./Barbell_Lunge/0.jpg": 16201,
	"./Barbell_Lunge/1.jpg": 54476,
	"./Barbell_Rear_Delt_Row/0.jpg": 66297,
	"./Barbell_Rear_Delt_Row/1.jpg": 52572,
	"./Barbell_Rollout_from_Bench/0.jpg": 49397,
	"./Barbell_Rollout_from_Bench/1.jpg": 42136,
	"./Barbell_Seated_Calf_Raise/0.jpg": 29200,
	"./Barbell_Seated_Calf_Raise/1.jpg": 30125,
	"./Barbell_Shoulder_Press/0.jpg": 11420,
	"./Barbell_Shoulder_Press/1.jpg": 55769,
	"./Barbell_Shrug/0.jpg": 64821,
	"./Barbell_Shrug/1.jpg": 56952,
	"./Barbell_Shrug_Behind_The_Back/0.jpg": 52202,
	"./Barbell_Shrug_Behind_The_Back/1.jpg": 19943,
	"./Barbell_Side_Bend/0.jpg": 53097,
	"./Barbell_Side_Bend/1.jpg": 55308,
	"./Barbell_Side_Split_Squat/0.jpg": 38851,
	"./Barbell_Side_Split_Squat/1.jpg": 74150,
	"./Barbell_Squat/0.jpg": 66714,
	"./Barbell_Squat/1.jpg": 54231,
	"./Barbell_Squat_To_A_Bench/0.jpg": 51561,
	"./Barbell_Squat_To_A_Bench/1.jpg": 79948,
	"./Barbell_Step_Ups/0.jpg": 24365,
	"./Barbell_Step_Ups/1.jpg": 79472,
	"./Barbell_Walking_Lunge/0.jpg": 69181,
	"./Barbell_Walking_Lunge/1.jpg": 29952,
	"./Battling_Ropes/0.jpg": 62566,
	"./Battling_Ropes/1.jpg": 1091,
	"./Bear_Crawl_Sled_Drags/0.jpg": 86050,
	"./Bear_Crawl_Sled_Drags/1.jpg": 6047,
	"./Behind_Head_Chest_Stretch/0.jpg": 54348,
	"./Behind_Head_Chest_Stretch/1.jpg": 25961,
	"./Bench_Dips/0.jpg": 63704,
	"./Bench_Dips/1.jpg": 68021,
	"./Bench_Jump/0.jpg": 12702,
	"./Bench_Jump/1.jpg": 60539,
	"./Bench_Press_-_Powerlifting/0.jpg": 35730,
	"./Bench_Press_-_Powerlifting/1.jpg": 3663,
	"./Bench_Press_-_With_Bands/0.jpg": 70955,
	"./Bench_Press_-_With_Bands/1.jpg": 91470,
	"./Bench_Press_with_Chains/0.jpg": 28419,
	"./Bench_Press_with_Chains/1.jpg": 38310,
	"./Bench_Sprint/0.jpg": 63366,
	"./Bench_Sprint/1.jpg": 53475,
	"./Bent-Arm_Barbell_Pullover/0.jpg": 1222,
	"./Bent-Arm_Barbell_Pullover/1.jpg": 44355,
	"./Bent-Arm_Dumbbell_Pullover/0.jpg": 15455,
	"./Bent-Arm_Dumbbell_Pullover/1.jpg": 2786,
	"./Bent-Knee_Hip_Raise/0.jpg": 64009,
	"./Bent-Knee_Hip_Raise/1.jpg": 25964,
	"./Bent_Over_Barbell_Row/0.jpg": 53087,
	"./Bent_Over_Barbell_Row/1.jpg": 61378,
	"./Bent_Over_Dumbbell_Rear_Delt_Raise_With_Head_On_Bench/0.jpg": 83872,
	"./Bent_Over_Dumbbell_Rear_Delt_Raise_With_Head_On_Bench/1.jpg": 51965,
	"./Bent_Over_Low-Pulley_Side_Lateral/0.jpg": 81688,
	"./Bent_Over_Low-Pulley_Side_Lateral/1.jpg": 72597,
	"./Bent_Over_One-Arm_Long_Bar_Row/0.jpg": 85007,
	"./Bent_Over_One-Arm_Long_Bar_Row/1.jpg": 8626,
	"./Bent_Over_Two-Arm_Long_Bar_Row/0.jpg": 89101,
	"./Bent_Over_Two-Arm_Long_Bar_Row/1.jpg": 4528,
	"./Bent_Over_Two-Dumbbell_Row/0.jpg": 4615,
	"./Bent_Over_Two-Dumbbell_Row/1.jpg": 92458,
	"./Bent_Over_Two-Dumbbell_Row_With_Palms_In/0.jpg": 56410,
	"./Bent_Over_Two-Dumbbell_Row_With_Palms_In/1.jpg": 20247,
	"./Bent_Press/0.jpg": 99526,
	"./Bent_Press/1.jpg": 89635,
	"./Bicycling/0.jpg": 41023,
	"./Bicycling/1.jpg": 28354,
	"./Bicycling_Stationary/0.jpg": 2436,
	"./Bicycling_Stationary/1.jpg": 80481,
	"./Board_Press/0.jpg": 86241,
	"./Board_Press/1.jpg": 8196,
	"./Body-Up/0.jpg": 12523,
	"./Body-Up/1.jpg": 34478,
	"./Body_Tricep_Press/0.jpg": 7163,
	"./Body_Tricep_Press/1.jpg": 87006,
	"./Bodyweight_Flyes/0.jpg": 36245,
	"./Bodyweight_Flyes/1.jpg": 28984,
	"./Bodyweight_Mid_Row/0.jpg": 81197,
	"./Bodyweight_Mid_Row/1.jpg": 80272,
	"./Bodyweight_Squat/0.jpg": 77144,
	"./Bodyweight_Squat/1.jpg": 81461,
	"./Bodyweight_Walking_Lunge/0.jpg": 49139,
	"./Bodyweight_Walking_Lunge/1.jpg": 93878,
	"./Bosu_Ball_Cable_Crunch_With_Side_Bends/0.jpg": 38038,
	"./Bosu_Ball_Cable_Crunch_With_Side_Bends/1.jpg": 1203,
	"./Bottoms-Up_Clean_From_The_Hang_Position/0.jpg": 48317,
	"./Bottoms-Up_Clean_From_The_Hang_Position/1.jpg": 92736,
	"./Bottoms_Up/0.jpg": 53143,
	"./Bottoms_Up/1.jpg": 81978,
	"./Box_Jump_Multiple_Response/0.jpg": 35762,
	"./Box_Jump_Multiple_Response/1.jpg": 12143,
	"./Box_Skip/0.jpg": 14916,
	"./Box_Skip/1.jpg": 92961,
	"./Box_Squat/0.jpg": 4437,
	"./Box_Squat/1.jpg": 43256,
	"./Box_Squat_with_Bands/0.jpg": 63249,
	"./Box_Squat_with_Bands/1.jpg": 84724,
	"./Box_Squat_with_Chains/0.jpg": 30109,
	"./Box_Squat_with_Chains/1.jpg": 4544,
	"./Brachialis-SMR/0.jpg": 51700,
	"./Brachialis-SMR/1.jpg": 66033,
	"./Bradford_Rocky_Presses/0.jpg": 30662,
	"./Bradford_Rocky_Presses/1.jpg": 69187,
	"./Butt-Ups/0.jpg": 58577,
	"./Butt-Ups/1.jpg": 86772,
	"./Butt_Lift_Bridge/0.jpg": 64556,
	"./Butt_Lift_Bridge/1.jpg": 9929,
	"./Butterfly/0.jpg": 35936,
	"./Butterfly/1.jpg": 45149,
	"./Cable_Chest_Press/0.jpg": 6360,
	"./Cable_Chest_Press/1.jpg": 10677,
	"./Cable_Crossover/0.jpg": 68209,
	"./Cable_Crossover/1.jpg": 89684,
	"./Cable_Crunch/0.jpg": 23794,
	"./Cable_Crunch/1.jpg": 91727,
	"./Cable_Deadlifts/0.jpg": 9711,
	"./Cable_Deadlifts/1.jpg": 33330,
	"./Cable_Hammer_Curls_-_Rope_Attachment/0.jpg": 57234,
	"./Cable_Hammer_Curls_-_Rope_Attachment/1.jpg": 17263,
	"./Cable_Hip_Adduction/0.jpg": 95786,
	"./Cable_Hip_Adduction/1.jpg": 51623,
	"./Cable_Incline_Pushdown/0.jpg": 51740,
	"./Cable_Incline_Pushdown/1.jpg": 49113,
	"./Cable_Incline_Triceps_Extension/0.jpg": 72942,
	"./Cable_Incline_Triceps_Extension/1.jpg": 99403,
	"./Cable_Internal_Rotation/0.jpg": 84659,
	"./Cable_Internal_Rotation/1.jpg": 21494,
	"./Cable_Iron_Cross/0.jpg": 54286,
	"./Cable_Iron_Cross/1.jpg": 50123,
	"./Cable_Judo_Flip/0.jpg": 88017,
	"./Cable_Judo_Flip/1.jpg": 16212,
	"./Cable_Lying_Triceps_Extension/0.jpg": 22139,
	"./Cable_Lying_Triceps_Extension/1.jpg": 20830,
	"./Cable_One_Arm_Tricep_Extension/0.jpg": 25132,
	"./Cable_One_Arm_Tricep_Extension/1.jpg": 39273,
	"./Cable_Preacher_Curl/0.jpg": 23982,
	"./Cable_Preacher_Curl/1.jpg": 19819,
	"./Cable_Rear_Delt_Fly/0.jpg": 71137,
	"./Cable_Rear_Delt_Fly/1.jpg": 93092,
	"./Cable_Reverse_Crunch/0.jpg": 54279,
	"./Cable_Reverse_Crunch/1.jpg": 42122,
	"./Cable_Rope_Overhead_Triceps_Extension/0.jpg": 15415,
	"./Cable_Rope_Overhead_Triceps_Extension/1.jpg": 44250,
	"./Cable_Rope_Rear-Delt_Rows/0.jpg": 27002,
	"./Cable_Rope_Rear-Delt_Rows/1.jpg": 14519,
	"./Cable_Russian_Twists/0.jpg": 11471,
	"./Cable_Russian_Twists/1.jpg": 35090,
	"./Cable_Seated_Crunch/0.jpg": 40115,
	"./Cable_Seated_Crunch/1.jpg": 76950,
	"./Cable_Seated_Lateral_Raise/0.jpg": 44236,
	"./Cable_Seated_Lateral_Raise/1.jpg": 89609,
	"./Cable_Shoulder_Press/0.jpg": 82109,
	"./Cable_Shoulder_Press/1.jpg": 30976,
	"./Cable_Shrugs/0.jpg": 1085,
	"./Cable_Shrugs/1.jpg": 49952,
	"./Cable_Wrist_Curl/0.jpg": 33463,
	"./Cable_Wrist_Curl/1.jpg": 81530,
	"./Calf-Machine_Shoulder_Shrug/0.jpg": 12432,
	"./Calf-Machine_Shoulder_Shrug/1.jpg": 57325,
	"./Calf_Press/0.jpg": 15905,
	"./Calf_Press/1.jpg": 42308,
	"./Calf_Press_On_The_Leg_Press_Machine/0.jpg": 18380,
	"./Calf_Press_On_The_Leg_Press_Machine/1.jpg": 16169,
	"./Calf_Raise_On_A_Dumbbell/0.jpg": 59500,
	"./Calf_Raise_On_A_Dumbbell/1.jpg": 97545,
	"./Calf_Raises_-_With_Bands/0.jpg": 55939,
	"./Calf_Raises_-_With_Bands/1.jpg": 17414,
	"./Calf_Stretch_Elbows_Against_Wall/0.jpg": 7633,
	"./Calf_Stretch_Elbows_Against_Wall/1.jpg": 29108,
	"./Calf_Stretch_Hands_Against_Wall/0.jpg": 79227,
	"./Calf_Stretch_Hands_Against_Wall/1.jpg": 59070,
	"./Calves-SMR/0.jpg": 39704,
	"./Calves-SMR/1.jpg": 84533,
	"./Car_Deadlift/0.jpg": 31199,
	"./Car_Deadlift/1.jpg": 39490,
	"./Car_Drivers/0.jpg": 88967,
	"./Car_Drivers/1.jpg": 66314,
	"./Carioca_Quick_Step/0.jpg": 61764,
	"./Carioca_Quick_Step/1.jpg": 39809,
	"./Cat_Stretch/0.jpg": 57599,
	"./Cat_Stretch/1.jpg": 37602,
	"./Catch_and_Overhead_Throw/0.jpg": 83979,
	"./Catch_and_Overhead_Throw/1.jpg": 14229,
	"./Chain_Handle_Extension/0.jpg": 61033,
	"./Chain_Handle_Extension/1.jpg": 15660,
	"./Chain_Press/0.jpg": 59622,
	"./Chain_Press/1.jpg": 2755,
	"./Chair_Leg_Extended_Stretch/0.jpg": 91023,
	"./Chair_Leg_Extended_Stretch/1.jpg": 18642,
	"./Chair_Lower_Back_Stretch/0.jpg": 21580,
	"./Chair_Lower_Back_Stretch/1.jpg": 93193,
	"./Chair_Squat/0.jpg": 63957,
	"./Chair_Squat/1.jpg": 56088,
	"./Chair_Upper_Body_Stretch/0.jpg": 37560,
	"./Chair_Upper_Body_Stretch/1.jpg": 98741,
	"./Chest_And_Front_Of_Shoulder_Stretch/0.jpg": 36121,
	"./Chest_And_Front_Of_Shoulder_Stretch/1.jpg": 8124,
	"./Chest_Push_from_3_point_stance/0.jpg": 33280,
	"./Chest_Push_from_3_point_stance/1.jpg": 58845,
	"./Chest_Push_multiple_response/0.jpg": 55878,
	"./Chest_Push_multiple_response/1.jpg": 99011,
	"./Chest_Push_single_response/0.jpg": 62338,
	"./Chest_Push_single_response/1.jpg": 82335,
	"./Chest_Push_with_Run_Release/0.jpg": 17052,
	"./Chest_Push_with_Run_Release/1.jpg": 61401,
	"./Chest_Stretch_on_Stability_Ball/0.jpg": 31836,
	"./Chest_Stretch_on_Stability_Ball/1.jpg": 18713,
	"./Childs_Pose/0.jpg": 81574,
	"./Childs_Pose/1.jpg": 24707,
	"./Chin-Up/0.jpg": 35095,
	"./Chin-Up/1.jpg": 47578,
	"./Chin_To_Chest_Stretch/0.jpg": 68729,
	"./Chin_To_Chest_Stretch/1.jpg": 55004,
	"./Circus_Bell/0.jpg": 51462,
	"./Circus_Bell/1.jpg": 10947,
	"./Clean/0.jpg": 37002,
	"./Clean/1.jpg": 49159,
	"./Clean_Deadlift/0.jpg": 37552,
	"./Clean_Deadlift/1.jpg": 22125,
	"./Clean_Pull/0.jpg": 32236,
	"./Clean_Pull/1.jpg": 77609,
	"./Clean_Shrug/0.jpg": 60646,
	"./Clean_Shrug/1.jpg": 50755,
	"./Clean_and_Jerk/0.jpg": 70089,
	"./Clean_and_Jerk/1.jpg": 14828,
	"./Clean_and_Press/0.jpg": 46880,
	"./Clean_and_Press/1.jpg": 14973,
	"./Clean_from_Blocks/0.jpg": 79874,
	"./Clean_from_Blocks/1.jpg": 71583,
	"./Clock_Push-Up/0.jpg": 76180,
	"./Clock_Push-Up/1.jpg": 90513,
	"./Close-Grip_Barbell_Bench_Press/0.jpg": 38080,
	"./Close-Grip_Barbell_Bench_Press/1.jpg": 89821,
	"./Close-Grip_Dumbbell_Press/0.jpg": 45438,
	"./Close-Grip_Dumbbell_Press/1.jpg": 46747,
	"./Close-Grip_EZ-Bar_Curl_with_Band/0.jpg": 47286,
	"./Close-Grip_EZ-Bar_Curl_with_Band/1.jpg": 75699,
	"./Close-Grip_EZ-Bar_Press/0.jpg": 55912,
	"./Close-Grip_EZ-Bar_Press/1.jpg": 83525,
	"./Close-Grip_EZ_Bar_Curl/0.jpg": 35875,
	"./Close-Grip_EZ_Bar_Curl/1.jpg": 76390,
	"./Close-Grip_Front_Lat_Pulldown/0.jpg": 16306,
	"./Close-Grip_Front_Lat_Pulldown/1.jpg": 92687,
	"./Close-Grip_Push-Up_off_of_a_Dumbbell/0.jpg": 41635,
	"./Close-Grip_Push-Up_off_of_a_Dumbbell/1.jpg": 82150,
	"./Close-Grip_Standing_Barbell_Curl/0.jpg": 79569,
	"./Close-Grip_Standing_Barbell_Curl/1.jpg": 65236,
	"./Cocoons/0.jpg": 62007,
	"./Cocoons/1.jpg": 51194,
	"./Conans_Wheel/0.jpg": 52703,
	"./Conans_Wheel/1.jpg": 44642,
	"./Concentration_Curls/0.jpg": 80114,
	"./Concentration_Curls/1.jpg": 48047,
	"./Cross-Body_Crunch/0.jpg": 2210,
	"./Cross-Body_Crunch/1.jpg": 22207,
	"./Cross_Body_Hammer_Curl/0.jpg": 86558,
	"./Cross_Body_Hammer_Curl/1.jpg": 34395,
	"./Cross_Over_-_With_Bands/0.jpg": 28004,
	"./Cross_Over_-_With_Bands/1.jpg": 6049,
	"./Crossover_Reverse_Lunge/0.jpg": 5608,
	"./Crossover_Reverse_Lunge/1.jpg": 32773,
	"./Crucifix/0.jpg": 56954,
	"./Crucifix/1.jpg": 8887,
	"./Crunch_-_Hands_Overhead/0.jpg": 58886,
	"./Crunch_-_Hands_Overhead/1.jpg": 48995,
	"./Crunch_-_Legs_On_Exercise_Ball/0.jpg": 67011,
	"./Crunch_-_Legs_On_Exercise_Ball/1.jpg": 23878,
	"./Crunches/0.jpg": 63620,
	"./Crunches/1.jpg": 41665,
	"./Cuban_Press/0.jpg": 61530,
	"./Cuban_Press/1.jpg": 25367,
	"./Dancers_Stretch/0.jpg": 54127,
	"./Dancers_Stretch/1.jpg": 86194,
	"./Dead_Bug/0.jpg": 75758,
	"./Dead_Bug/1.jpg": 71595,
	"./Deadlift_with_Bands/0.jpg": 36328,
	"./Deadlift_with_Bands/1.jpg": 98693,
	"./Deadlift_with_Chains/0.jpg": 69210,
	"./Deadlift_with_Chains/1.jpg": 33047,
	"./Decline_Barbell_Bench_Press/0.jpg": 23261,
	"./Decline_Barbell_Bench_Press/1.jpg": 26758,
	"./Decline_Close-Grip_Bench_To_Skull_Crusher/0.jpg": 67811,
	"./Decline_Close-Grip_Bench_To_Skull_Crusher/1.jpg": 45638,
	"./Decline_Crunch/0.jpg": 49489,
	"./Decline_Crunch/1.jpg": 35156,
	"./Decline_Dumbbell_Bench_Press/0.jpg": 12314,
	"./Decline_Dumbbell_Bench_Press/1.jpg": 80599,
	"./Decline_Dumbbell_Flyes/0.jpg": 56819,
	"./Decline_Dumbbell_Flyes/1.jpg": 70358,
	"./Decline_Dumbbell_Triceps_Extension/0.jpg": 65254,
	"./Decline_Dumbbell_Triceps_Extension/1.jpg": 55363,
	"./Decline_EZ_Bar_Triceps_Extension/0.jpg": 5378,
	"./Decline_EZ_Bar_Triceps_Extension/1.jpg": 25375,
	"./Decline_Oblique_Crunch/0.jpg": 70729,
	"./Decline_Oblique_Crunch/1.jpg": 99116,
	"./Decline_Push-Up/0.jpg": 16152,
	"./Decline_Push-Up/1.jpg": 24021,
	"./Decline_Reverse_Crunch/0.jpg": 17440,
	"./Decline_Reverse_Crunch/1.jpg": 68573,
	"./Decline_Smith_Press/0.jpg": 68731,
	"./Decline_Smith_Press/1.jpg": 32222,
	"./Deficit_Deadlift/0.jpg": 46359,
	"./Deficit_Deadlift/1.jpg": 78074,
	"./Depth_Jump_Leap/0.jpg": 72470,
	"./Depth_Jump_Leap/1.jpg": 883,
	"./Dip_Machine/0.jpg": 24440,
	"./Dip_Machine/1.jpg": 32309,
	"./Dips_-_Chest_Version/0.jpg": 64786,
	"./Dips_-_Chest_Version/1.jpg": 37167,
	"./Dips_-_Triceps_Version/0.jpg": 24897,
	"./Dips_-_Triceps_Version/1.jpg": 46852,
	"./Donkey_Calf_Raises/0.jpg": 70472,
	"./Donkey_Calf_Raises/1.jpg": 14437,
	"./Double_Kettlebell_Alternating_Hang_Clean/0.jpg": 74920,
	"./Double_Kettlebell_Alternating_Hang_Clean/1.jpg": 18885,
	"./Double_Kettlebell_Jerk/0.jpg": 36522,
	"./Double_Kettlebell_Jerk/1.jpg": 4263,
	"./Double_Kettlebell_Push_Press/0.jpg": 96752,
	"./Double_Kettlebell_Push_Press/1.jpg": 23853,
	"./Double_Kettlebell_Snatch/0.jpg": 9349,
	"./Double_Kettlebell_Snatch/1.jpg": 81736,
	"./Double_Kettlebell_Windmill/0.jpg": 2284,
	"./Double_Kettlebell_Windmill/1.jpg": 16425,
	"./Double_Leg_Butt_Kick/0.jpg": 17088,
	"./Double_Leg_Butt_Kick/1.jpg": 42653,
	"./Downward_Facing_Balance/0.jpg": 52375,
	"./Downward_Facing_Balance/1.jpg": 81210,
	"./Drag_Curl/0.jpg": 1694,
	"./Drag_Curl/1.jpg": 72827,
	"./Drop_Push/0.jpg": 92599,
	"./Drop_Push/1.jpg": 28762,
	"./Dumbbell_Alternate_Bicep_Curl/0.jpg": 21552,
	"./Dumbbell_Alternate_Bicep_Curl/1.jpg": 90125,
	"./Dumbbell_Bench_Press/0.jpg": 1795,
	"./Dumbbell_Bench_Press/1.jpg": 11686,
	"./Dumbbell_Bench_Press_with_Neutral_Grip/0.jpg": 6269,
	"./Dumbbell_Bench_Press_with_Neutral_Grip/1.jpg": 71488,
	"./Dumbbell_Bicep_Curl/0.jpg": 93797,
	"./Dumbbell_Bicep_Curl/1.jpg": 49832,
	"./Dumbbell_Clean/0.jpg": 14546,
	"./Dumbbell_Clean/1.jpg": 90927,
	"./Dumbbell_Floor_Press/0.jpg": 85499,
	"./Dumbbell_Floor_Press/1.jpg": 84190,
	"./Dumbbell_Flyes/0.jpg": 57502,
	"./Dumbbell_Flyes/1.jpg": 12283,
	"./Dumbbell_Incline_Row/0.jpg": 9242,
	"./Dumbbell_Incline_Row/1.jpg": 3703,
	"./Dumbbell_Incline_Shoulder_Raise/0.jpg": 91755,
	"./Dumbbell_Incline_Shoulder_Raise/1.jpg": 12270,
	"./Dumbbell_Lunges/0.jpg": 96507,
	"./Dumbbell_Lunges/1.jpg": 65022,
	"./Dumbbell_Lying_One-Arm_Rear_Lateral_Raise/0.jpg": 91058,
	"./Dumbbell_Lying_One-Arm_Rear_Lateral_Raise/1.jpg": 75343,
	"./Dumbbell_Lying_Pronation/0.jpg": 19315,
	"./Dumbbell_Lying_Pronation/1.jpg": 56150,
	"./Dumbbell_Lying_Rear_Lateral_Raise/0.jpg": 11138,
	"./Dumbbell_Lying_Rear_Lateral_Raise/1.jpg": 2847,
	"./Dumbbell_Lying_Supination/0.jpg": 26949,
	"./Dumbbell_Lying_Supination/1.jpg": 82984,
	"./Dumbbell_One-Arm_Shoulder_Press/0.jpg": 95667,
	"./Dumbbell_One-Arm_Shoulder_Press/1.jpg": 9206,
	"./Dumbbell_One-Arm_Triceps_Extension/0.jpg": 67967,
	"./Dumbbell_One-Arm_Triceps_Extension/1.jpg": 76258,
	"./Dumbbell_One-Arm_Upright_Row/0.jpg": 39803,
	"./Dumbbell_One-Arm_Upright_Row/1.jpg": 38494,
	"./Dumbbell_Prone_Incline_Curl/0.jpg": 47797,
	"./Dumbbell_Prone_Incline_Curl/1.jpg": 43480,
	"./Dumbbell_Raise/0.jpg": 9005,
	"./Dumbbell_Raise/1.jpg": 64112,
	"./Dumbbell_Rear_Lunge/0.jpg": 75181,
	"./Dumbbell_Rear_Lunge/1.jpg": 90608,
	"./Dumbbell_Scaption/0.jpg": 75704,
	"./Dumbbell_Scaption/1.jpg": 80021,
	"./Dumbbell_Seated_Box_Jump/0.jpg": 18132,
	"./Dumbbell_Seated_Box_Jump/1.jpg": 96657,
	"./Dumbbell_Seated_One-Leg_Calf_Raise/0.jpg": 77447,
	"./Dumbbell_Seated_One-Leg_Calf_Raise/1.jpg": 5258,
	"./Dumbbell_Shoulder_Press/0.jpg": 26867,
	"./Dumbbell_Shoulder_Press/1.jpg": 40406,
	"./Dumbbell_Shrug/0.jpg": 32136,
	"./Dumbbell_Shrug/1.jpg": 76101,
	"./Dumbbell_Side_Bend/0.jpg": 62832,
	"./Dumbbell_Side_Bend/1.jpg": 7725,
	"./Dumbbell_Squat/0.jpg": 38123,
	"./Dumbbell_Squat/1.jpg": 60078,
	"./Dumbbell_Squat_To_A_Bench/0.jpg": 94738,
	"./Dumbbell_Squat_To_A_Bench/1.jpg": 71119,
	"./Dumbbell_Step_Ups/0.jpg": 73638,
	"./Dumbbell_Step_Ups/1.jpg": 63747,
	"./Dumbbell_Tricep_Extension_-Pronated_Grip/0.jpg": 70880,
	"./Dumbbell_Tricep_Extension_-Pronated_Grip/1.jpg": 96445,
	"./Dynamic_Back_Stretch/0.jpg": 41046,
	"./Dynamic_Back_Stretch/1.jpg": 69459,
	"./Dynamic_Chest_Stretch/0.jpg": 64882,
	"./Dynamic_Chest_Stretch/1.jpg": 37263,
	"./EZ-Bar_Curl/0.jpg": 45303,
	"./EZ-Bar_Curl/1.jpg": 81466,
	"./EZ-Bar_Skullcrusher/0.jpg": 63064,
	"./EZ-Bar_Skullcrusher/1.jpg": 70933,
	"./Elbow_Circles/0.jpg": 35010,
	"./Elbow_Circles/1.jpg": 71359,
	"./Elbow_to_Knee/0.jpg": 25930,
	"./Elbow_to_Knee/1.jpg": 38087,
	"./Elbows_Back/0.jpg": 90255,
	"./Elbows_Back/1.jpg": 30226,
	"./Elevated_Back_Lunge/0.jpg": 27433,
	"./Elevated_Back_Lunge/1.jpg": 29644,
	"./Elevated_Cable_Rows/0.jpg": 87257,
	"./Elevated_Cable_Rows/1.jpg": 16732,
	"./Elliptical_Trainer/0.jpg": 10200,
	"./Elliptical_Trainer/1.jpg": 34421,
	"./Exercise_Ball_Crunch/0.jpg": 92837,
	"./Exercise_Ball_Crunch/1.jpg": 65672,
	"./Exercise_Ball_Pull-In/0.jpg": 74969,
	"./Exercise_Ball_Pull-In/1.jpg": 53916,
	"./Extended_Range_One-Arm_Kettlebell_Floor_Press/0.jpg": 50028,
	"./Extended_Range_One-Arm_Kettlebell_Floor_Press/1.jpg": 21641,
	"./External_Rotation/0.jpg": 59387,
	"./External_Rotation/1.jpg": 39230,
	"./External_Rotation_with_Band/0.jpg": 86116,
	"./External_Rotation_with_Band/1.jpg": 76065,
	"./External_Rotation_with_Cable/0.jpg": 31052,
	"./External_Rotation_with_Cable/1.jpg": 28841,
	"./Face_Pull/0.jpg": 38346,
	"./Face_Pull/1.jpg": 94183,
	"./Farmers_Walk/0.jpg": 24875,
	"./Farmers_Walk/1.jpg": 46830,
	"./Fast_Skipping/0.jpg": 57705,
	"./Fast_Skipping/1.jpg": 19660,
	"./Finger_Curls/0.jpg": 78848,
	"./Finger_Curls/1.jpg": 4413,
	"./Flat_Bench_Cable_Flyes/0.jpg": 1505,
	"./Flat_Bench_Cable_Flyes/1.jpg": 23460,
	"./Flat_Bench_Leg_Pull-In/0.jpg": 29142,
	"./Flat_Bench_Leg_Pull-In/1.jpg": 15603,
	"./Flat_Bench_Lying_Leg_Raise/0.jpg": 85847,
	"./Flat_Bench_Lying_Leg_Raise/1.jpg": 91386,
	"./Flexor_Incline_Dumbbell_Curls/0.jpg": 93154,
	"./Flexor_Incline_Dumbbell_Curls/1.jpg": 5823,
	"./Floor_Glute-Ham_Raise/0.jpg": 38513,
	"./Floor_Glute-Ham_Raise/1.jpg": 24788,
	"./Floor_Press/0.jpg": 32819,
	"./Floor_Press/1.jpg": 46358,
	"./Floor_Press_with_Chains/0.jpg": 64507,
	"./Floor_Press_with_Chains/1.jpg": 79550,
	"./Flutter_Kicks/0.jpg": 95087,
	"./Flutter_Kicks/1.jpg": 18706,
	"./Foot-SMR/0.jpg": 25674,
	"./Foot-SMR/1.jpg": 93415,
	"./Forward_Drag_with_Press/0.jpg": 68178,
	"./Forward_Drag_with_Press/1.jpg": 44559,
	"./Frankenstein_Squat/0.jpg": 7928,
	"./Frankenstein_Squat/1.jpg": 15797,
	"./Freehand_Jump_Squat/0.jpg": 56518,
	"./Freehand_Jump_Squat/1.jpg": 95043,
	"./Frog_Hops/0.jpg": 57984,
	"./Frog_Hops/1.jpg": 9117,
	"./Frog_Sit-Ups/0.jpg": 66833,
	"./Frog_Sit-Ups/1.jpg": 95028,
	"./Front_Barbell_Squat/0.jpg": 48446,
	"./Front_Barbell_Squat/1.jpg": 96283,
	"./Front_Barbell_Squat_To_A_Bench/0.jpg": 87965,
	"./Front_Barbell_Squat_To_A_Bench/1.jpg": 48736,
	"./Front_Box_Jump/0.jpg": 80333,
	"./Front_Box_Jump/1.jpg": 28112,
	"./Front_Cable_Raise/0.jpg": 84083,
	"./Front_Cable_Raise/1.jpg": 55670,
	"./Front_Cone_Hops_or_hurdle_hops/0.jpg": 83099,
	"./Front_Cone_Hops_or_hurdle_hops/1.jpg": 81790,
	"./Front_Dumbbell_Raise/0.jpg": 61769,
	"./Front_Dumbbell_Raise/1.jpg": 90156,
	"./Front_Incline_Dumbbell_Raise/0.jpg": 72028,
	"./Front_Incline_Dumbbell_Raise/1.jpg": 25,
	"./Front_Leg_Raises/0.jpg": 55339,
	"./Front_Leg_Raises/1.jpg": 77294,
	"./Front_Plate_Raise/0.jpg": 52412,
	"./Front_Plate_Raise/1.jpg": 73465,
	"./Front_Raise_And_Pullover/0.jpg": 53881,
	"./Front_Raise_And_Pullover/1.jpg": 32828,
	"./Front_Squat_Clean_Grip/0.jpg": 39432,
	"./Front_Squat_Clean_Grip/1.jpg": 66597,
	"./Front_Squats_With_Two_Kettlebells/0.jpg": 49590,
	"./Front_Squats_With_Two_Kettlebells/1.jpg": 12755,
	"./Front_Two-Dumbbell_Raise/0.jpg": 36562,
	"./Front_Two-Dumbbell_Raise/1.jpg": 4495,
	"./Full_Range-Of-Motion_Lat_Pulldown/0.jpg": 93441,
	"./Full_Range-Of-Motion_Lat_Pulldown/1.jpg": 15396,
	"./Gironda_Sternum_Chins/0.jpg": 97030,
	"./Gironda_Sternum_Chins/1.jpg": 87139,
	"./Glute_Ham_Raise/0.jpg": 228,
	"./Glute_Ham_Raise/1.jpg": 78273,
	"./Glute_Kickback/0.jpg": 61966,
	"./Glute_Kickback/1.jpg": 40011,
	"./Goblet_Squat/0.jpg": 14339,
	"./Goblet_Squat/1.jpg": 75814,
	"./Good_Morning/0.jpg": 86697,
	"./Good_Morning/1.jpg": 48652,
	"./Good_Morning_off_Pins/0.jpg": 73622,
	"./Good_Morning_off_Pins/1.jpg": 36787,
	"./Gorilla_Chin_Crunch/0.jpg": 32174,
	"./Gorilla_Chin_Crunch/1.jpg": 11659,
	"./Groin_and_Back_Stretch/0.jpg": 55080,
	"./Groin_and_Back_Stretch/1.jpg": 98597,
	"./Groiners/0.jpg": 15026,
	"./Groiners/1.jpg": 99311,
	"./Hack_Squat/0.jpg": 74347,
	"./Hack_Squat/1.jpg": 96302,
	"./Hammer_Curls/0.jpg": 30845,
	"./Hammer_Curls/1.jpg": 79712,
	"./Hammer_Grip_Incline_DB_Bench_Press/0.jpg": 1923,
	"./Hammer_Grip_Incline_DB_Bench_Press/1.jpg": 20870,
	"./Hamstring-SMR/0.jpg": 53413,
	"./Hamstring-SMR/1.jpg": 91048,
	"./Hamstring_Stretch/0.jpg": 65294,
	"./Hamstring_Stretch/1.jpg": 43339,
	"./Handstand_Push-Ups/0.jpg": 67834,
	"./Handstand_Push-Ups/1.jpg": 19767,
	"./Hang_Clean/0.jpg": 43897,
	"./Hang_Clean/1.jpg": 57020,
	"./Hang_Clean_-_Below_the_Knees/0.jpg": 12086,
	"./Hang_Clean_-_Below_the_Knees/1.jpg": 98547,
	"./Hang_Snatch/0.jpg": 28519,
	"./Hang_Snatch/1.jpg": 5866,
	"./Hang_Snatch_-_Below_Knees/0.jpg": 2644,
	"./Hang_Snatch_-_Below_Knees/1.jpg": 81169,
	"./Hanging_Bar_Good_Morning/0.jpg": 58664,
	"./Hanging_Bar_Good_Morning/1.jpg": 4677,
	"./Hanging_Leg_Raise/0.jpg": 19349,
	"./Hanging_Leg_Raise/1.jpg": 11480,
	"./Hanging_Pike/0.jpg": 11669,
	"./Hanging_Pike/1.jpg": 20760,
	"./Heaving_Snatch_Balance/0.jpg": 67704,
	"./Heaving_Snatch_Balance/1.jpg": 28885,
	"./Heavy_Bag_Thrust/0.jpg": 11292,
	"./Heavy_Bag_Thrust/1.jpg": 55641,
	"./High_Cable_Curls/0.jpg": 74549,
	"./High_Cable_Curls/1.jpg": 70232,
	"./Hip_Circles_prone/0.jpg": 85279,
	"./Hip_Circles_prone/1.jpg": 77218,
	"./Hip_Extension_with_Bands/0.jpg": 69878,
	"./Hip_Extension_with_Bands/1.jpg": 14643,
	"./Hip_Flexion_with_Band/0.jpg": 72333,
	"./Hip_Flexion_with_Band/1.jpg": 28880,
	"./Hip_Lift_with_Band/0.jpg": 95045,
	"./Hip_Lift_with_Band/1.jpg": 67432,
	"./Hug_A_Ball/0.jpg": 54879,
	"./Hug_A_Ball/1.jpg": 63170,
	"./Hug_Knees_To_Chest/0.jpg": 42218,
	"./Hug_Knees_To_Chest/1.jpg": 98055,
	"./Hurdle_Hops/0.jpg": 28464,
	"./Hurdle_Hops/1.jpg": 55565,
	"./Hyperextensions_Back_Extensions/0.jpg": 16738,
	"./Hyperextensions_Back_Extensions/1.jpg": 8447,
	"./Hyperextensions_With_No_Hyperextension_Bench/0.jpg": 57963,
	"./Hyperextensions_With_No_Hyperextension_Bench/1.jpg": 79918,
	"./IT_Band_and_Glute_Stretch/0.jpg": 87264,
	"./IT_Band_and_Glute_Stretch/1.jpg": 12829,
	"./Iliotibial_Tract-SMR/0.jpg": 56067,
	"./Iliotibial_Tract-SMR/1.jpg": 75014,
	"./Inchworm/0.jpg": 31814,
	"./Inchworm/1.jpg": 96515,
	"./Incline_Barbell_Triceps_Extension/0.jpg": 74413,
	"./Incline_Barbell_Triceps_Extension/1.jpg": 29520,
	"./Incline_Bench_Pull/0.jpg": 77146,
	"./Incline_Bench_Pull/1.jpg": 29079,
	"./Incline_Cable_Chest_Press/0.jpg": 42819,
	"./Incline_Cable_Chest_Press/1.jpg": 99686,
	"./Incline_Cable_Flye/0.jpg": 204,
	"./Incline_Cable_Flye/1.jpg": 55465,
	"./Incline_Dumbbell_Bench_With_Palms_Facing_In/0.jpg": 25854,
	"./Incline_Dumbbell_Bench_With_Palms_Facing_In/1.jpg": 96987,
	"./Incline_Dumbbell_Curl/0.jpg": 42162,
	"./Incline_Dumbbell_Curl/1.jpg": 26447,
	"./Incline_Dumbbell_Flyes/0.jpg": 88011,
	"./Incline_Dumbbell_Flyes/1.jpg": 8526,
	"./Incline_Dumbbell_Flyes_-_With_A_Twist/0.jpg": 53886,
	"./Incline_Dumbbell_Flyes_-_With_A_Twist/1.jpg": 25019,
	"./Incline_Dumbbell_Press/0.jpg": 26101,
	"./Incline_Dumbbell_Press/1.jpg": 21784,
	"./Incline_Hammer_Curls/0.jpg": 59368,
	"./Incline_Hammer_Curls/1.jpg": 3333,
	"./Incline_Inner_Biceps_Curl/0.jpg": 1050,
	"./Incline_Inner_Biceps_Curl/1.jpg": 64887,
	"./Incline_Push-Up/0.jpg": 83808,
	"./Incline_Push-Up/1.jpg": 23037,
	"./Incline_Push-Up_Close-Grip/0.jpg": 89742,
	"./Incline_Push-Up_Close-Grip/1.jpg": 67787,
	"./Incline_Push-Up_Depth_Jump/0.jpg": 43701,
	"./Incline_Push-Up_Depth_Jump/1.jpg": 35832,
	"./Incline_Push-Up_Medium/0.jpg": 49994,
	"./Incline_Push-Up_Medium/1.jpg": 17735,
	"./Incline_Push-Up_Reverse_Grip/0.jpg": 38354,
	"./Incline_Push-Up_Reverse_Grip/1.jpg": 14735,
	"./Incline_Push-Up_Wide/0.jpg": 12202,
	"./Incline_Push-Up_Wide/1.jpg": 6772,
	"./Intermediate_Groin_Stretch/0.jpg": 19816,
	"./Intermediate_Groin_Stretch/1.jpg": 82181,
	"./Intermediate_Hip_Flexor_and_Quad_Stretch/0.jpg": 23031,
	"./Intermediate_Hip_Flexor_and_Quad_Stretch/1.jpg": 71098,
	"./Internal_Rotation_with_Band/0.jpg": 78006,
	"./Internal_Rotation_with_Band/1.jpg": 33267,
	"./Inverted_Row/0.jpg": 27813,
	"./Inverted_Row/1.jpg": 200,
	"./Inverted_Row_with_Straps/0.jpg": 95062,
	"./Inverted_Row_with_Straps/1.jpg": 58227,
	"./Iron_Cross/0.jpg": 1580,
	"./Iron_Cross/1.jpg": 63305,
	"./Iron_Crosses_stretch/0.jpg": 47802,
	"./Iron_Crosses_stretch/1.jpg": 11639,
	"./Isometric_Chest_Squeezes/0.jpg": 61491,
	"./Isometric_Chest_Squeezes/1.jpg": 9437,
	"./Isometric_Neck_Exercise_-_Front_And_Back/0.jpg": 94335,
	"./Isometric_Neck_Exercise_-_Front_And_Back/1.jpg": 81666,
	"./Isometric_Neck_Exercise_-_Sides/0.jpg": 69484,
	"./Isometric_Neck_Exercise_-_Sides/1.jpg": 7529,
	"./Isometric_Wipers/0.jpg": 66401,
	"./Isometric_Wipers/1.jpg": 88356,
	"./JM_Press/0.jpg": 71964,
	"./JM_Press/1.jpg": 93017,
	"./Jackknife_Sit-Up/0.jpg": 52922,
	"./Jackknife_Sit-Up/1.jpg": 4855,
	"./Janda_Sit-Up/0.jpg": 1604,
	"./Janda_Sit-Up/1.jpg": 79649,
	"./Jefferson_Squats/0.jpg": 87727,
	"./Jefferson_Squats/1.jpg": 19794,
	"./Jerk_Balance/0.jpg": 10628,
	"./Jerk_Balance/1.jpg": 88673,
	"./Jerk_Dip_Squat/0.jpg": 41300,
	"./Jerk_Dip_Squat/1.jpg": 19825,
	"./Jogging_Treadmill/0.jpg": 80591,
	"./Jogging_Treadmill/1.jpg": 4210,
	"./Keg_Load/0.jpg": 62233,
	"./Keg_Load/1.jpg": 41180,
	"./Kettlebell_Arnold_Press/0.jpg": 84340,
	"./Kettlebell_Arnold_Press/1.jpg": 62865,
	"./Kettlebell_Dead_Clean/0.jpg": 9128,
	"./Kettlebell_Dead_Clean/1.jpg": 71493,
	"./Kettlebell_Figure_8/0.jpg": 27597,
	"./Kettlebell_Figure_8/1.jpg": 84144,
	"./Kettlebell_Hang_Clean/0.jpg": 57306,
	"./Kettlebell_Hang_Clean/1.jpg": 9239,
	"./Kettlebell_One-Legged_Deadlift/0.jpg": 59089,
	"./Kettlebell_One-Legged_Deadlift/1.jpg": 45364,
	"./Kettlebell_Pass_Between_The_Legs/0.jpg": 18354,
	"./Kettlebell_Pass_Between_The_Legs/1.jpg": 86287,
	"./Kettlebell_Pirate_Ships/0.jpg": 38003,
	"./Kettlebell_Pirate_Ships/1.jpg": 82742,
	"./Kettlebell_Pistol_Squat/0.jpg": 60538,
	"./Kettlebell_Pistol_Squat/1.jpg": 71351,
	"./Kettlebell_Seated_Press/0.jpg": 10540,
	"./Kettlebell_Seated_Press/1.jpg": 55913,
	"./Kettlebell_Seesaw_Press/0.jpg": 36560,
	"./Kettlebell_Seesaw_Press/1.jpg": 88781,
	"./Kettlebell_Sumo_High_Pull/0.jpg": 66047,
	"./Kettlebell_Sumo_High_Pull/1.jpg": 53378,
	"./Kettlebell_Thruster/0.jpg": 32483,
	"./Kettlebell_Thruster/1.jpg": 93958,
	"./Kettlebell_Turkish_Get-Up_Lunge_style/0.jpg": 67795,
	"./Kettlebell_Turkish_Get-Up_Lunge_style/1.jpg": 23030,
	"./Kettlebell_Turkish_Get-Up_Squat_style/0.jpg": 28204,
	"./Kettlebell_Turkish_Get-Up_Squat_style/1.jpg": 99817,
	"./Kettlebell_Windmill/0.jpg": 37588,
	"./Kettlebell_Windmill/1.jpg": 51921,
	"./Kipping_Muscle_Up/0.jpg": 94743,
	"./Kipping_Muscle_Up/1.jpg": 282,
	"./Knee_Across_The_Body/0.jpg": 40421,
	"./Knee_Across_The_Body/1.jpg": 78056,
	"./Knee_Circles/0.jpg": 96988,
	"./Knee_Circles/1.jpg": 41337,
	"./Knee_Hip_Raise_On_Parallel_Bars/0.jpg": 74128,
	"./Knee_Hip_Raise_On_Parallel_Bars/1.jpg": 42701,
	"./Knee_Tuck_Jump/0.jpg": 54389,
	"./Knee_Tuck_Jump/1.jpg": 46520,
	"./Kneeling_Arm_Drill/0.jpg": 57063,
	"./Kneeling_Arm_Drill/1.jpg": 89322,
	"./Kneeling_Cable_Crunch_With_Alternating_Oblique_Twists/0.jpg": 47492,
	"./Kneeling_Cable_Crunch_With_Alternating_Oblique_Twists/1.jpg": 25537,
	"./Kneeling_Cable_Triceps_Extension/0.jpg": 11499,
	"./Kneeling_Cable_Triceps_Extension/1.jpg": 15662,
	"./Kneeling_Forearm_Stretch/0.jpg": 88177,
	"./Kneeling_Forearm_Stretch/1.jpg": 16372,
	"./Kneeling_High_Pulley_Row/0.jpg": 38694,
	"./Kneeling_High_Pulley_Row/1.jpg": 77219,
	"./Kneeling_Hip_Flexor/0.jpg": 34653,
	"./Kneeling_Hip_Flexor/1.jpg": 99872,
	"./Kneeling_Jump_Squat/0.jpg": 95550,
	"./Kneeling_Jump_Squat/1.jpg": 15707,
	"./Kneeling_Single-Arm_High_Pulley_Row/0.jpg": 87612,
	"./Kneeling_Single-Arm_High_Pulley_Row/1.jpg": 1337,
	"./Kneeling_Squat/0.jpg": 28517,
	"./Kneeling_Squat/1.jpg": 85000,
	"./Landmine_180s/0.jpg": 1752,
	"./Landmine_180s/1.jpg": 62933,
	"./Landmine_Linear_Jammer/0.jpg": 37774,
	"./Landmine_Linear_Jammer/1.jpg": 33611,
	"./Lateral_Bound/0.jpg": 58165,
	"./Lateral_Bound/1.jpg": 53848,
	"./Lateral_Box_Jump/0.jpg": 31797,
	"./Lateral_Box_Jump/1.jpg": 23928,
	"./Lateral_Cone_Hops/0.jpg": 43745,
	"./Lateral_Cone_Hops/1.jpg": 65700,
	"./Lateral_Raise_-_With_Bands/0.jpg": 14713,
	"./Lateral_Raise_-_With_Bands/1.jpg": 93660,
	"./Latissimus_Dorsi-SMR/0.jpg": 66832,
	"./Latissimus_Dorsi-SMR/1.jpg": 67757,
	"./Leg-Over_Floor_Press/0.jpg": 53231,
	"./Leg-Over_Floor_Press/1.jpg": 80850,
	"./Leg-Up_Hamstring_Stretch/0.jpg": 9583,
	"./Leg-Up_Hamstring_Stretch/1.jpg": 41650,
	"./Leg_Extensions/0.jpg": 59302,
	"./Leg_Extensions/1.jpg": 24003,
	"./Leg_Lift/0.jpg": 22547,
	"./Leg_Lift/1.jpg": 50934,
	"./Leg_Press/0.jpg": 349,
	"./Leg_Press/1.jpg": 49216,
	"./Leg_Pull-In/0.jpg": 34187,
	"./Leg_Pull-In/1.jpg": 56142,
	"./Leverage_Chest_Press/0.jpg": 90260,
	"./Leverage_Chest_Press/1.jpg": 4593,
	"./Leverage_Deadlift/0.jpg": 89436,
	"./Leverage_Deadlift/1.jpg": 33785,
	"./Leverage_Decline_Chest_Press/0.jpg": 80579,
	"./Leverage_Decline_Chest_Press/1.jpg": 77145,
	"./Leverage_High_Row/0.jpg": 69308,
	"./Leverage_High_Row/1.jpg": 90361,
	"./Leverage_Incline_Chest_Press/0.jpg": 50487,
	"./Leverage_Incline_Chest_Press/1.jpg": 86650,
	"./Leverage_Iso_Row/0.jpg": 85341,
	"./Leverage_Iso_Row/1.jpg": 59776,
	"./Leverage_Shoulder_Press/0.jpg": 86889,
	"./Leverage_Shoulder_Press/1.jpg": 48844,
	"./Leverage_Shrug/0.jpg": 59962,
	"./Leverage_Shrug/1.jpg": 23799,
	"./Linear_3-Part_Start_Technique/0.jpg": 27130,
	"./Linear_3-Part_Start_Technique/1.jpg": 98295,
	"./Linear_Acceleration_Wall_Drill/0.jpg": 64400,
	"./Linear_Acceleration_Wall_Drill/1.jpg": 16621,
	"./Linear_Depth_Jump/0.jpg": 35169,
	"./Linear_Depth_Jump/1.jpg": 61572,
	"./Log_Lift/0.jpg": 77057,
	"./Log_Lift/1.jpg": 87108,
	"./London_Bridges/0.jpg": 20262,
	"./London_Bridges/1.jpg": 63395,
	"./Looking_At_Ceiling/0.jpg": 47186,
	"./Looking_At_Ceiling/1.jpg": 23567,
	"./Low_Cable_Crossover/0.jpg": 4374,
	"./Low_Cable_Crossover/1.jpg": 90835,
	"./Low_Cable_Triceps_Extension/0.jpg": 83718,
	"./Low_Cable_Triceps_Extension/1.jpg": 26851,
	"./Low_Pulley_Row_To_Neck/0.jpg": 93590,
	"./Low_Pulley_Row_To_Neck/1.jpg": 48851,
	"./Lower_Back-SMR/0.jpg": 93101,
	"./Lower_Back-SMR/1.jpg": 92176,
	"./Lower_Back_Curl/0.jpg": 26509,
	"./Lower_Back_Curl/1.jpg": 25584,
	"./Lunge_Pass_Through/0.jpg": 46930,
	"./Lunge_Pass_Through/1.jpg": 14863,
	"./Lunge_Sprint/0.jpg": 87355,
	"./Lunge_Sprint/1.jpg": 32574,
	"./Lying_Bent_Leg_Groin/0.jpg": 90767,
	"./Lying_Bent_Leg_Groin/1.jpg": 14386,
	"./Lying_Cable_Curl/0.jpg": 79413,
	"./Lying_Cable_Curl/1.jpg": 71544,
	"./Lying_Cambered_Barbell_Row/0.jpg": 56086,
	"./Lying_Cambered_Barbell_Row/1.jpg": 42547,
	"./Lying_Close-Grip_Bar_Curl_On_High_Pulley/0.jpg": 99956,
	"./Lying_Close-Grip_Bar_Curl_On_High_Pulley/1.jpg": 14289,
	"./Lying_Close-Grip_Barbell_Triceps_Extension_Behind_The_Head/0.jpg": 38622,
	"./Lying_Close-Grip_Barbell_Triceps_Extension_Behind_The_Head/1.jpg": 23579,
	"./Lying_Close-Grip_Barbell_Triceps_Press_To_Chin/0.jpg": 59627,
	"./Lying_Close-Grip_Barbell_Triceps_Press_To_Chin/1.jpg": 81582,
	"./Lying_Crossover/0.jpg": 49733,
	"./Lying_Crossover/1.jpg": 22568,
	"./Lying_Dumbbell_Tricep_Extension/0.jpg": 72622,
	"./Lying_Dumbbell_Tricep_Extension/1.jpg": 68459,
	"./Lying_Face_Down_Plate_Neck_Resistance/0.jpg": 486,
	"./Lying_Face_Down_Plate_Neck_Resistance/1.jpg": 74243,
	"./Lying_Face_Up_Plate_Neck_Resistance/0.jpg": 72621,
	"./Lying_Face_Up_Plate_Neck_Resistance/1.jpg": 88048,
	"./Lying_Glute/0.jpg": 98808,
	"./Lying_Glute/1.jpg": 6677,
	"./Lying_Hamstring/0.jpg": 12822,
	"./Lying_Hamstring/1.jpg": 75987,
	"./Lying_High_Bench_Barbell_Curl/0.jpg": 16728,
	"./Lying_High_Bench_Barbell_Curl/1.jpg": 7637,
	"./Lying_Leg_Curls/0.jpg": 33579,
	"./Lying_Leg_Curls/1.jpg": 55534,
	"./Lying_Machine_Squat/0.jpg": 64271,
	"./Lying_Machine_Squat/1.jpg": 96338,
	"./Lying_One-Arm_Lateral_Raise/0.jpg": 27199,
	"./Lying_One-Arm_Lateral_Raise/1.jpg": 35490,
	"./Lying_Prone_Quadriceps/0.jpg": 51645,
	"./Lying_Prone_Quadriceps/1.jpg": 512,
	"./Lying_Rear_Delt_Raise/0.jpg": 22622,
	"./Lying_Rear_Delt_Raise/1.jpg": 23931,
	"./Lying_Supine_Dumbbell_Curl/0.jpg": 81454,
	"./Lying_Supine_Dumbbell_Curl/1.jpg": 59499,
	"./Lying_T-Bar_Row/0.jpg": 34446,
	"./Lying_T-Bar_Row/1.jpg": 12491,
	"./Lying_Triceps_Press/0.jpg": 92307,
	"./Lying_Triceps_Press/1.jpg": 37046,
	"./Machine_Bench_Press/0.jpg": 51641,
	"./Machine_Bench_Press/1.jpg": 7292,
	"./Machine_Bicep_Curl/0.jpg": 98991,
	"./Machine_Bicep_Curl/1.jpg": 22610,
	"./Machine_Preacher_Curls/0.jpg": 89373,
	"./Machine_Preacher_Curls/1.jpg": 50144,
	"./Machine_Shoulder_Military_Press/0.jpg": 78261,
	"./Machine_Shoulder_Military_Press/1.jpg": 73944,
	"./Machine_Triceps_Extension/0.jpg": 12921,
	"./Machine_Triceps_Extension/1.jpg": 91868,
	"./Medicine_Ball_Chest_Pass/0.jpg": 84717,
	"./Medicine_Ball_Chest_Pass/1.jpg": 57616,
	"./Medicine_Ball_Full_Twist/0.jpg": 6263,
	"./Medicine_Ball_Full_Twist/1.jpg": 35098,
	"./Medicine_Ball_Scoop_Throw/0.jpg": 66961,
	"./Medicine_Ball_Scoop_Throw/1.jpg": 36276,
	"./Middle_Back_Shrug/0.jpg": 83018,
	"./Middle_Back_Shrug/1.jpg": 22023,
	"./Middle_Back_Stretch/0.jpg": 85788,
	"./Middle_Back_Stretch/1.jpg": 30137,
	"./Mixed_Grip_Chin/0.jpg": 66058,
	"./Mixed_Grip_Chin/1.jpg": 21895,
	"./Monster_Walk/0.jpg": 51829,
	"./Monster_Walk/1.jpg": 44568,
	"./Mountain_Climbers/0.jpg": 64564,
	"./Mountain_Climbers/1.jpg": 78289,
	"./Moving_Claw_Series/0.jpg": 82139,
	"./Moving_Claw_Series/1.jpg": 27358,
	"./Muscle_Snatch/0.jpg": 75096,
	"./Muscle_Snatch/1.jpg": 1794,
	"./Muscle_Up/0.jpg": 38482,
	"./Muscle_Up/1.jpg": 22767,
	"./Narrow_Stance_Hack_Squats/0.jpg": 16539,
	"./Narrow_Stance_Hack_Squats/1.jpg": 15230,
	"./Narrow_Stance_Leg_Press/0.jpg": 14448,
	"./Narrow_Stance_Leg_Press/1.jpg": 83021,
	"./Narrow_Stance_Squats/0.jpg": 2941,
	"./Narrow_Stance_Squats/1.jpg": 77376,
	"./Natural_Glute_Ham_Raise/0.jpg": 52538,
	"./Natural_Glute_Ham_Raise/1.jpg": 23703,
	"./Neck-SMR/0.jpg": 84499,
	"./Neck-SMR/1.jpg": 29238,
	"./Neck_Press/0.jpg": 21210,
	"./Neck_Press/1.jpg": 15671,
	"./Oblique_Crunches/0.jpg": 77844,
	"./Oblique_Crunches/1.jpg": 92177,
	"./Oblique_Crunches_-_On_The_Floor/0.jpg": 42631,
	"./Oblique_Crunches_-_On_The_Floor/1.jpg": 91242,
	"./Olympic_Squat/0.jpg": 39711,
	"./Olympic_Squat/1.jpg": 48002,
	"./On-Your-Back_Quad_Stretch/0.jpg": 29028,
	"./On-Your-Back_Quad_Stretch/1.jpg": 2625,
	"./On_Your_Side_Quad_Stretch/0.jpg": 27956,
	"./On_Your_Side_Quad_Stretch/1.jpg": 6481,
	"./One-Arm_Dumbbell_Row/0.jpg": 43073,
	"./One-Arm_Dumbbell_Row/1.jpg": 65028,
	"./One-Arm_Flat_Bench_Dumbbell_Flye/0.jpg": 6486,
	"./One-Arm_Flat_Bench_Dumbbell_Flye/1.jpg": 69651,
	"./One-Arm_High-Pulley_Cable_Side_Bends/0.jpg": 30996,
	"./One-Arm_High-Pulley_Cable_Side_Bends/1.jpg": 45329,
	"./One-Arm_Incline_Lateral_Raise/0.jpg": 94310,
	"./One-Arm_Incline_Lateral_Raise/1.jpg": 32835,
	"./One-Arm_Kettlebell_Clean/0.jpg": 62551,
	"./One-Arm_Kettlebell_Clean/1.jpg": 98714,
	"./One-Arm_Kettlebell_Clean_and_Jerk/0.jpg": 23506,
	"./One-Arm_Kettlebell_Clean_and_Jerk/1.jpg": 83535,
	"./One-Arm_Kettlebell_Floor_Press/0.jpg": 51790,
	"./One-Arm_Kettlebell_Floor_Press/1.jpg": 46187,
	"./One-Arm_Kettlebell_Jerk/0.jpg": 70773,
	"./One-Arm_Kettlebell_Jerk/1.jpg": 29503,
	"./One-Arm_Kettlebell_Military_Press_To_The_Side/0.jpg": 37463,
	"./One-Arm_Kettlebell_Military_Press_To_The_Side/1.jpg": 43002,
	"./One-Arm_Kettlebell_Para_Press/0.jpg": 45262,
	"./One-Arm_Kettlebell_Para_Press/1.jpg": 71723,
	"./One-Arm_Kettlebell_Push_Press/0.jpg": 38152,
	"./One-Arm_Kettlebell_Push_Press/1.jpg": 65317,
	"./One-Arm_Kettlebell_Row/0.jpg": 95240,
	"./One-Arm_Kettlebell_Row/1.jpg": 57605,
	"./One-Arm_Kettlebell_Snatch/0.jpg": 96925,
	"./One-Arm_Kettlebell_Snatch/1.jpg": 28832,
	"./One-Arm_Kettlebell_Split_Jerk/0.jpg": 93313,
	"./One-Arm_Kettlebell_Split_Jerk/1.jpg": 3364,
	"./One-Arm_Kettlebell_Split_Snatch/0.jpg": 55326,
	"./One-Arm_Kettlebell_Split_Snatch/1.jpg": 10107,
	"./One-Arm_Kettlebell_Swings/0.jpg": 88457,
	"./One-Arm_Kettlebell_Swings/1.jpg": 50412,
	"./One-Arm_Long_Bar_Row/0.jpg": 2838,
	"./One-Arm_Long_Bar_Row/1.jpg": 89299,
	"./One-Arm_Medicine_Ball_Slam/0.jpg": 10951,
	"./One-Arm_Medicine_Ball_Slam/1.jpg": 59562,
	"./One-Arm_Open_Palm_Kettlebell_Clean/0.jpg": 45521,
	"./One-Arm_Open_Palm_Kettlebell_Clean/1.jpg": 73716,
	"./One-Arm_Overhead_Kettlebell_Squats/0.jpg": 15990,
	"./One-Arm_Overhead_Kettlebell_Squats/1.jpg": 60755,
	"./One-Arm_Side_Deadlift/0.jpg": 91200,
	"./One-Arm_Side_Deadlift/1.jpg": 42941,
	"./One-Arm_Side_Laterals/0.jpg": 597,
	"./One-Arm_Side_Laterals/1.jpg": 92728,
	"./One-Legged_Cable_Kickback/0.jpg": 15952,
	"./One-Legged_Cable_Kickback/1.jpg": 59405,
	"./One_Arm_Against_Wall/0.jpg": 24297,
	"./One_Arm_Against_Wall/1.jpg": 26508,
	"./One_Arm_Chin-Up/0.jpg": 94325,
	"./One_Arm_Chin-Up/1.jpg": 49496,
	"./One_Arm_Dumbbell_Bench_Press/0.jpg": 8101,
	"./One_Arm_Dumbbell_Bench_Press/1.jpg": 64136,
	"./One_Arm_Dumbbell_Preacher_Curl/0.jpg": 89858,
	"./One_Arm_Dumbbell_Preacher_Curl/1.jpg": 86175,
	"./One_Arm_Floor_Press/0.jpg": 51665,
	"./One_Arm_Floor_Press/1.jpg": 37940,
	"./One_Arm_Lat_Pulldown/0.jpg": 62366,
	"./One_Arm_Lat_Pulldown/1.jpg": 33499,
	"./One_Arm_Pronated_Dumbbell_Triceps_Extension/0.jpg": 6667,
	"./One_Arm_Pronated_Dumbbell_Triceps_Extension/1.jpg": 28622,
	"./One_Arm_Supinated_Dumbbell_Triceps_Extension/0.jpg": 62733,
	"./One_Arm_Supinated_Dumbbell_Triceps_Extension/1.jpg": 10512,
	"./One_Half_Locust/0.jpg": 76124,
	"./One_Half_Locust/1.jpg": 20473,
	"./One_Handed_Hang/0.jpg": 78843,
	"./One_Handed_Hang/1.jpg": 77534,
	"./One_Knee_To_Chest/0.jpg": 44213,
	"./One_Knee_To_Chest/1.jpg": 83032,
	"./One_Leg_Barbell_Squat/0.jpg": 60370,
	"./One_Leg_Barbell_Squat/1.jpg": 36751,
	"./Open_Palm_Kettlebell_Clean/0.jpg": 3009,
	"./Open_Palm_Kettlebell_Clean/1.jpg": 13060,
	"./Otis-Up/0.jpg": 46936,
	"./Otis-Up/1.jpg": 54805,
	"./Overhead_Cable_Curl/0.jpg": 82374,
	"./Overhead_Cable_Curl/1.jpg": 63427,
	"./Overhead_Lat/0.jpg": 29369,
	"./Overhead_Lat/1.jpg": 58844,
	"./Overhead_Slam/0.jpg": 95909,
	"./Overhead_Slam/1.jpg": 68744,
	"./Overhead_Squat/0.jpg": 1704,
	"./Overhead_Squat/1.jpg": 29317,
	"./Overhead_Stretch/0.jpg": 52493,
	"./Overhead_Stretch/1.jpg": 67920,
	"./Overhead_Triceps/0.jpg": 11618,
	"./Overhead_Triceps/1.jpg": 31615,
	"./Pallof_Press/0.jpg": 54305,
	"./Pallof_Press/1.jpg": 76260,
	"./Pallof_Press_With_Rotation/0.jpg": 87325,
	"./Pallof_Press_With_Rotation/1.jpg": 61760,
	"./Palms-Down_Dumbbell_Wrist_Curl_Over_A_Bench/0.jpg": 30700,
	"./Palms-Down_Dumbbell_Wrist_Curl_Over_A_Bench/1.jpg": 2313,
	"./Palms-Down_Wrist_Curl_Over_A_Bench/0.jpg": 53550,
	"./Palms-Down_Wrist_Curl_Over_A_Bench/1.jpg": 31595,
	"./Palms-Up_Barbell_Wrist_Curl_Over_A_Bench/0.jpg": 12424,
	"./Palms-Up_Barbell_Wrist_Curl_Over_A_Bench/1.jpg": 56389,
	"./Palms-Up_Dumbbell_Wrist_Curl_Over_A_Bench/0.jpg": 25417,
	"./Palms-Up_Dumbbell_Wrist_Curl_Over_A_Bench/1.jpg": 80044,
	"./Parallel_Bar_Dip/0.jpg": 4446,
	"./Parallel_Bar_Dip/1.jpg": 24603,
	"./Pelvic_Tilt_Into_Bridge/0.jpg": 933,
	"./Pelvic_Tilt_Into_Bridge/1.jpg": 38568,
	"./Peroneals-SMR/0.jpg": 5667,
	"./Peroneals-SMR/1.jpg": 40966,
	"./Peroneals_Stretch/0.jpg": 23044,
	"./Peroneals_Stretch/1.jpg": 1089,
	"./Physioball_Hip_Bridge/0.jpg": 46974,
	"./Physioball_Hip_Bridge/1.jpg": 94811,
	"./Pin_Presses/0.jpg": 27324,
	"./Pin_Presses/1.jpg": 48377,
	"./Piriformis-SMR/0.jpg": 71274,
	"./Piriformis-SMR/1.jpg": 10279,
	"./Plank/0.jpg": 11685,
	"./Plank/1.jpg": 67720,
	"./Plate_Pinch/0.jpg": 12092,
	"./Plate_Pinch/1.jpg": 56441,
	"./Plate_Twist/0.jpg": 70289,
	"./Plate_Twist/1.jpg": 56564,
	"./Platform_Hamstring_Slides/0.jpg": 2967,
	"./Platform_Hamstring_Slides/1.jpg": 31802,
	"./Plie_Dumbbell_Squat/0.jpg": 71104,
	"./Plie_Dumbbell_Squat/1.jpg": 22845,
	"./Plyo_Kettlebell_Pushups/0.jpg": 99639,
	"./Plyo_Kettlebell_Pushups/1.jpg": 28474,
	"./Plyo_Push-up/0.jpg": 45644,
	"./Plyo_Push-up/1.jpg": 83689,
	"./Posterior_Tibialis_Stretch/0.jpg": 79614,
	"./Posterior_Tibialis_Stretch/1.jpg": 80923,
	"./Power_Clean/0.jpg": 77104,
	"./Power_Clean/1.jpg": 78029,
	"./Power_Clean_from_Blocks/0.jpg": 54632,
	"./Power_Clean_from_Blocks/1.jpg": 20978,
	"./Power_Jerk/0.jpg": 2639,
	"./Power_Jerk/1.jpg": 26258,
	"./Power_Partials/0.jpg": 18059,
	"./Power_Partials/1.jpg": 91598,
	"./Power_Snatch/0.jpg": 81948,
	"./Power_Snatch/1.jpg": 68825,
	"./Power_Snatch_from_Blocks/0.jpg": 11980,
	"./Power_Snatch_from_Blocks/1.jpg": 9769,
	"./Power_Stairs/0.jpg": 22815,
	"./Power_Stairs/1.jpg": 14754,
	"./Preacher_Curl/0.jpg": 86380,
	"./Preacher_Curl/1.jpg": 41641,
	"./Preacher_Hammer_Dumbbell_Curl/0.jpg": 78045,
	"./Preacher_Hammer_Dumbbell_Curl/1.jpg": 26304,
	"./Press_Sit-Up/0.jpg": 37249,
	"./Press_Sit-Up/1.jpg": 59204,
	"./Prone_Manual_Hamstring/0.jpg": 17460,
	"./Prone_Manual_Hamstring/1.jpg": 5617,
	"./Prowler_Sprint/0.jpg": 16367,
	"./Prowler_Sprint/1.jpg": 32082,
	"./Pull_Through/0.jpg": 27548,
	"./Pull_Through/1.jpg": 32249,
	"./Pullups/0.jpg": 83972,
	"./Pullups/1.jpg": 57569,
	"./Push-Up_Wide/0.jpg": 42215,
	"./Push-Up_Wide/1.jpg": 86378,
	"./Push-Ups_-_Close_Triceps_Position/0.jpg": 61020,
	"./Push-Ups_-_Close_Triceps_Position/1.jpg": 82073,
	"./Push-Ups_With_Feet_Elevated/0.jpg": 91281,
	"./Push-Ups_With_Feet_Elevated/1.jpg": 19476,
	"./Push-Ups_With_Feet_On_An_Exercise_Ball/0.jpg": 18869,
	"./Push-Ups_With_Feet_On_An_Exercise_Ball/1.jpg": 27960,
	"./Push_Press/0.jpg": 57947,
	"./Push_Press/1.jpg": 3166,
	"./Push_Press_-_Behind_the_Neck/0.jpg": 27160,
	"./Push_Press_-_Behind_the_Neck/1.jpg": 31477,
	"./Push_Up_to_Side_Plank/0.jpg": 77058,
	"./Push_Up_to_Side_Plank/1.jpg": 89727,
	"./Pushups/0.jpg": 53279,
	"./Pushups/1.jpg": 61570,
	"./Pushups_Close_and_Wide_Hand_Positions/0.jpg": 60299,
	"./Pushups_Close_and_Wide_Hand_Positions/1.jpg": 82254,
	"./Pyramid/0.jpg": 11717,
	"./Pyramid/1.jpg": 49352,
	"./Quad_Stretch/0.jpg": 33212,
	"./Quad_Stretch/1.jpg": 54265,
	"./Quadriceps-SMR/0.jpg": 46759,
	"./Quadriceps-SMR/1.jpg": 50954,
	"./Quick_Leap/0.jpg": 39073,
	"./Quick_Leap/1.jpg": 61028,
	"./Rack_Delivery/0.jpg": 73553,
	"./Rack_Delivery/1.jpg": 1748,
	"./Rack_Pull_with_Bands/0.jpg": 29454,
	"./Rack_Pull_with_Bands/1.jpg": 55915,
	"./Rack_Pulls/0.jpg": 50143,
	"./Rack_Pulls/1.jpg": 37474,
	"./Rear_Leg_Raises/0.jpg": 33416,
	"./Rear_Leg_Raises/1.jpg": 95781,
	"./Recumbent_Bike/0.jpg": 2592,
	"./Recumbent_Bike/1.jpg": 58173,
	"./Return_Push_from_Stance/0.jpg": 87334,
	"./Return_Push_from_Stance/1.jpg": 46819,
	"./Reverse_Band_Bench_Press/0.jpg": 43304,
	"./Reverse_Band_Bench_Press/1.jpg": 87269,
	"./Reverse_Band_Box_Squat/0.jpg": 8062,
	"./Reverse_Band_Box_Squat/1.jpg": 62843,
	"./Reverse_Band_Deadlift/0.jpg": 5091,
	"./Reverse_Band_Deadlift/1.jpg": 66566,
	"./Reverse_Band_Power_Squat/0.jpg": 72382,
	"./Reverse_Band_Power_Squat/1.jpg": 92539,
	"./Reverse_Band_Sumo_Deadlift/0.jpg": 15996,
	"./Reverse_Band_Sumo_Deadlift/1.jpg": 29721,
	"./Reverse_Barbell_Curl/0.jpg": 41135,
	"./Reverse_Barbell_Curl/1.jpg": 81106,
	"./Reverse_Barbell_Preacher_Curls/0.jpg": 70821,
	"./Reverse_Barbell_Preacher_Curls/1.jpg": 27304,
	"./Reverse_Cable_Curl/0.jpg": 99502,
	"./Reverse_Cable_Curl/1.jpg": 78987,
	"./Reverse_Crunch/0.jpg": 45949,
	"./Reverse_Crunch/1.jpg": 94208,
	"./Reverse_Flyes/0.jpg": 94861,
	"./Reverse_Flyes/1.jpg": 49968,
	"./Reverse_Flyes_With_External_Rotation/0.jpg": 29319,
	"./Reverse_Flyes_With_External_Rotation/1.jpg": 73482,
	"./Reverse_Grip_Bent-Over_Rows/0.jpg": 5017,
	"./Reverse_Grip_Bent-Over_Rows/1.jpg": 18140,
	"./Reverse_Grip_Triceps_Pushdown/0.jpg": 874,
	"./Reverse_Grip_Triceps_Pushdown/1.jpg": 56711,
	"./Reverse_Hyperextension/0.jpg": 59311,
	"./Reverse_Hyperextension/1.jpg": 82930,
	"./Reverse_Machine_Flyes/0.jpg": 38139,
	"./Reverse_Machine_Flyes/1.jpg": 6654,
	"./Reverse_Plate_Curls/0.jpg": 76318,
	"./Reverse_Plate_Curls/1.jpg": 31099,
	"./Reverse_Triceps_Bench_Press/0.jpg": 82433,
	"./Reverse_Triceps_Bench_Press/1.jpg": 8836,
	"./Rhomboids-SMR/0.jpg": 66895,
	"./Rhomboids-SMR/1.jpg": 90514,
	"./Rickshaw_Carry/0.jpg": 12635,
	"./Rickshaw_Carry/1.jpg": 64798,
	"./Rickshaw_Deadlift/0.jpg": 88155,
	"./Rickshaw_Deadlift/1.jpg": 67998,
	"./Ring_Dips/0.jpg": 94958,
	"./Ring_Dips/1.jpg": 21419,
	"./Rocket_Jump/0.jpg": 50562,
	"./Rocket_Jump/1.jpg": 58623,
	"./Rocking_Standing_Calf_Raise/0.jpg": 11545,
	"./Rocking_Standing_Calf_Raise/1.jpg": 6844,
	"./Rocky_Pull-Ups_Pulldowns/0.jpg": 14057,
	"./Rocky_Pull-Ups_Pulldowns/1.jpg": 52332,
	"./Romanian_Deadlift/0.jpg": 93944,
	"./Romanian_Deadlift/1.jpg": 38773,
	"./Romanian_Deadlift_from_Deficit/0.jpg": 32224,
	"./Romanian_Deadlift_from_Deficit/1.jpg": 317,
	"./Rope_Climb/0.jpg": 93841,
	"./Rope_Climb/1.jpg": 79508,
	"./Rope_Crunch/0.jpg": 19881,
	"./Rope_Crunch/1.jpg": 64620,
	"./Rope_Jumping/0.jpg": 2922,
	"./Rope_Jumping/1.jpg": 70663,
	"./Rope_Straight-Arm_Pulldown/0.jpg": 51266,
	"./Rope_Straight-Arm_Pulldown/1.jpg": 21016,
	"./Round_The_World_Shoulder_Stretch/0.jpg": 49301,
	"./Round_The_World_Shoulder_Stretch/1.jpg": 42040,
	"./Rowing_Stationary/0.jpg": 95792,
	"./Rowing_Stationary/1.jpg": 48013,
	"./Runners_Stretch/0.jpg": 96634,
	"./Runners_Stretch/1.jpg": 60471,
	"./Running_Treadmill/0.jpg": 86091,
	"./Running_Treadmill/1.jpg": 59630,
	"./Russian_Twist/0.jpg": 33938,
	"./Russian_Twist/1.jpg": 10319,
	"./Sandbag_Load/0.jpg": 72812,
	"./Sandbag_Load/1.jpg": 18185,
	"./Scapular_Pull-Up/0.jpg": 15092,
	"./Scapular_Pull-Up/1.jpg": 86897,
	"./Scissor_Kick/0.jpg": 51672,
	"./Scissor_Kick/1.jpg": 12853,
	"./Scissors_Jump/0.jpg": 60133,
	"./Scissors_Jump/1.jpg": 97768,
	"./Seated_Band_Hamstring_Curl/0.jpg": 7176,
	"./Seated_Band_Hamstring_Curl/1.jpg": 51141,
	"./Seated_Barbell_Military_Press/0.jpg": 7924,
	"./Seated_Barbell_Military_Press/1.jpg": 5297,
	"./Seated_Barbell_Twist/0.jpg": 10462,
	"./Seated_Barbell_Twist/1.jpg": 11771,
	"./Seated_Bent-Over_One-Arm_Dumbbell_Triceps_Extension/0.jpg": 36101,
	"./Seated_Bent-Over_One-Arm_Dumbbell_Triceps_Extension/1.jpg": 92136,
	"./Seated_Bent-Over_Rear_Delt_Raise/0.jpg": 77030,
	"./Seated_Bent-Over_Rear_Delt_Raise/1.jpg": 58083,
	"./Seated_Bent-Over_Two-Arm_Dumbbell_Triceps_Extension/0.jpg": 57811,
	"./Seated_Bent-Over_Two-Arm_Dumbbell_Triceps_Extension/1.jpg": 94646,
	"./Seated_Biceps/0.jpg": 51418,
	"./Seated_Biceps/1.jpg": 45879,
	"./Seated_Cable_Rows/0.jpg": 31655,
	"./Seated_Cable_Rows/1.jpg": 63914,
	"./Seated_Cable_Shoulder_Press/0.jpg": 30500,
	"./Seated_Cable_Shoulder_Press/1.jpg": 8545,
	"./Seated_Calf_Raise/0.jpg": 64641,
	"./Seated_Calf_Raise/1.jpg": 86596,
	"./Seated_Calf_Stretch/0.jpg": 25758,
	"./Seated_Calf_Stretch/1.jpg": 57243,
	"./Seated_Close-Grip_Concentration_Barbell_Curl/0.jpg": 79950,
	"./Seated_Close-Grip_Concentration_Barbell_Curl/1.jpg": 79524,
	"./Seated_Dumbbell_Curl/0.jpg": 22290,
	"./Seated_Dumbbell_Curl/1.jpg": 98671,
	"./Seated_Dumbbell_Inner_Biceps_Curl/0.jpg": 4956,
	"./Seated_Dumbbell_Inner_Biceps_Curl/1.jpg": 18681,
	"./Seated_Dumbbell_Palms-Down_Wrist_Curl/0.jpg": 83473,
	"./Seated_Dumbbell_Palms-Down_Wrist_Curl/1.jpg": 11668,
	"./Seated_Dumbbell_Palms-Up_Wrist_Curl/0.jpg": 23304,
	"./Seated_Dumbbell_Palms-Up_Wrist_Curl/1.jpg": 85669,
	"./Seated_Dumbbell_Press/0.jpg": 87573,
	"./Seated_Dumbbell_Press/1.jpg": 80312,
	"./Seated_Flat_Bench_Leg_Pull-In/0.jpg": 54439,
	"./Seated_Flat_Bench_Leg_Pull-In/1.jpg": 42282,
	"./Seated_Floor_Hamstring_Stretch/0.jpg": 82090,
	"./Seated_Floor_Hamstring_Stretch/1.jpg": 77895,
	"./Seated_Front_Deltoid/0.jpg": 23669,
	"./Seated_Front_Deltoid/1.jpg": 15800,
	"./Seated_Glute/0.jpg": 39441,
	"./Seated_Glute/1.jpg": 25108,
	"./Seated_Good_Mornings/0.jpg": 2159,
	"./Seated_Good_Mornings/1.jpg": 29778,
	"./Seated_Hamstring/0.jpg": 11627,
	"./Seated_Hamstring/1.jpg": 32142,
	"./Seated_Hamstring_and_Calf_Stretch/0.jpg": 23504,
	"./Seated_Hamstring_and_Calf_Stretch/1.jpg": 24429,
	"./Seated_Head_Harness_Neck_Resistance/0.jpg": 38443,
	"./Seated_Head_Harness_Neck_Resistance/1.jpg": 42606,
	"./Seated_Leg_Curl/0.jpg": 23263,
	"./Seated_Leg_Curl/1.jpg": 26946,
	"./Seated_Leg_Tucks/0.jpg": 74545,
	"./Seated_Leg_Tucks/1.jpg": 2740,
	"./Seated_One-Arm_Dumbbell_Palms-Down_Wrist_Curl/0.jpg": 33069,
	"./Seated_One-Arm_Dumbbell_Palms-Down_Wrist_Curl/1.jpg": 32144,
	"./Seated_One-Arm_Dumbbell_Palms-Up_Wrist_Curl/0.jpg": 40220,
	"./Seated_One-Arm_Dumbbell_Palms-Up_Wrist_Curl/1.jpg": 84569,
	"./Seated_One-arm_Cable_Pulley_Rows/0.jpg": 88133,
	"./Seated_One-arm_Cable_Pulley_Rows/1.jpg": 44168,
	"./Seated_Overhead_Stretch/0.jpg": 30936,
	"./Seated_Overhead_Stretch/1.jpg": 35253,
	"./Seated_Palm-Up_Barbell_Wrist_Curl/0.jpg": 62030,
	"./Seated_Palm-Up_Barbell_Wrist_Curl/1.jpg": 57867,
	"./Seated_Palms-Down_Barbell_Wrist_Curl/0.jpg": 32696,
	"./Seated_Palms-Down_Barbell_Wrist_Curl/1.jpg": 39957,
	"./Seated_Side_Lateral_Raise/0.jpg": 41386,
	"./Seated_Side_Lateral_Raise/1.jpg": 37191,
	"./Seated_Triceps_Press/0.jpg": 11626,
	"./Seated_Triceps_Press/1.jpg": 34279,
	"./Seated_Two-Arm_Palms-Up_Low-Pulley_Wrist_Curl/0.jpg": 27911,
	"./Seated_Two-Arm_Palms-Up_Low-Pulley_Wrist_Curl/1.jpg": 60170,
	"./See-Saw_Press_Alternating_Side_Press/0.jpg": 40236,
	"./See-Saw_Press_Alternating_Side_Press/1.jpg": 95497,
	"./Shotgun_Row/0.jpg": 90046,
	"./Shotgun_Row/1.jpg": 44827,
	"./Shoulder_Circles/0.jpg": 67685,
	"./Shoulder_Circles/1.jpg": 40072,
	"./Shoulder_Press_-_With_Bands/0.jpg": 47739,
	"./Shoulder_Press_-_With_Bands/1.jpg": 92958,
	"./Shoulder_Raise/0.jpg": 81154,
	"./Shoulder_Raise/1.jpg": 1151,
	"./Shoulder_Stretch/0.jpg": 68533,
	"./Shoulder_Stretch/1.jpg": 60664,
	"./Side-Lying_Floor_Stretch/0.jpg": 3007,
	"./Side-Lying_Floor_Stretch/1.jpg": 11298,
	"./Side_Bridge/0.jpg": 32906,
	"./Side_Bridge/1.jpg": 71911,
	"./Side_Hop-Sprint/0.jpg": 81095,
	"./Side_Hop-Sprint/1.jpg": 13354,
	"./Side_Jackknife/0.jpg": 57783,
	"./Side_Jackknife/1.jpg": 93946,
	"./Side_Lateral_Raise/0.jpg": 32899,
	"./Side_Lateral_Raise/1.jpg": 94374,
	"./Side_Laterals_to_Front_Raise/0.jpg": 10998,
	"./Side_Laterals_to_Front_Raise/1.jpg": 74163,
	"./Side_Leg_Raises/0.jpg": 93825,
	"./Side_Leg_Raises/1.jpg": 15780,
	"./Side_Lying_Groin_Stretch/0.jpg": 37960,
	"./Side_Lying_Groin_Stretch/1.jpg": 325,
	"./Side_Neck_Stretch/0.jpg": 98038,
	"./Side_Neck_Stretch/1.jpg": 68147,
	"./Side_Standing_Long_Jump/0.jpg": 47213,
	"./Side_Standing_Long_Jump/1.jpg": 3760,
	"./Side_To_Side_Chins/0.jpg": 99834,
	"./Side_To_Side_Chins/1.jpg": 70999,
	"./Side_Wrist_Pull/0.jpg": 34828,
	"./Side_Wrist_Pull/1.jpg": 72873,
	"./Side_to_Side_Box_Shuffle/0.jpg": 64140,
	"./Side_to_Side_Box_Shuffle/1.jpg": 9513,
	"./Single-Arm_Cable_Crossover/0.jpg": 98795,
	"./Single-Arm_Cable_Crossover/1.jpg": 20750,
	"./Single-Arm_Linear_Jammer/0.jpg": 95073,
	"./Single-Arm_Linear_Jammer/1.jpg": 17028,
	"./Single-Arm_Push-Up/0.jpg": 19633,
	"./Single-Arm_Push-Up/1.jpg": 5908,
	"./Single-Cone_Sprint_Drill/0.jpg": 30834,
	"./Single-Cone_Sprint_Drill/1.jpg": 7215,
	"./Single-Leg_High_Box_Squat/0.jpg": 79734,
	"./Single-Leg_High_Box_Squat/1.jpg": 42899,
	"./Single-Leg_Hop_Progression/0.jpg": 57712,
	"./Single-Leg_Hop_Progression/1.jpg": 42285,
	"./Single-Leg_Lateral_Hop/0.jpg": 12904,
	"./Single-Leg_Lateral_Hop/1.jpg": 56869,
	"./Single-Leg_Leg_Extension/0.jpg": 90171,
	"./Single-Leg_Leg_Extension/1.jpg": 5214,
	"./Single-Leg_Stride_Jump/0.jpg": 74803,
	"./Single-Leg_Stride_Jump/1.jpg": 88342,
	"./Single_Dumbbell_Raise/0.jpg": 56936,
	"./Single_Dumbbell_Raise/1.jpg": 901,
	"./Single_Leg_Butt_Kick/0.jpg": 40795,
	"./Single_Leg_Butt_Kick/1.jpg": 86014,
	"./Single_Leg_Glute_Bridge/0.jpg": 9544,
	"./Single_Leg_Glute_Bridge/1.jpg": 55557,
	"./Single_Leg_Push-off/0.jpg": 21637,
	"./Single_Leg_Push-off/1.jpg": 77672,
	"./Sit-Up/0.jpg": 9706,
	"./Sit-Up/1.jpg": 31744,
	"./Sit_Squats/0.jpg": 82849,
	"./Sit_Squats/1.jpg": 4804,
	"./Skating/0.jpg": 46126,
	"./Skating/1.jpg": 72587,
	"./Sled_Drag_-_Harness/0.jpg": 90319,
	"./Sled_Drag_-_Harness/1.jpg": 6034,
	"./Sled_Overhead_Backward_Walk/0.jpg": 34116,
	"./Sled_Overhead_Backward_Walk/1.jpg": 12161,
	"./Sled_Overhead_Triceps_Extension/0.jpg": 55039,
	"./Sled_Overhead_Triceps_Extension/1.jpg": 42370,
	"./Sled_Push/0.jpg": 32444,
	"./Sled_Push/1.jpg": 76793,
	"./Sled_Reverse_Flye/0.jpg": 58861,
	"./Sled_Reverse_Flye/1.jpg": 6640,
	"./Sled_Row/0.jpg": 42728,
	"./Sled_Row/1.jpg": 86693,
	"./Sledgehammer_Swings/0.jpg": 27239,
	"./Sledgehammer_Swings/1.jpg": 71402,
	"./Smith_Incline_Shoulder_Raise/0.jpg": 60483,
	"./Smith_Incline_Shoulder_Raise/1.jpg": 70374,
	"./Smith_Machine_Behind_the_Back_Shrug/0.jpg": 34801,
	"./Smith_Machine_Behind_the_Back_Shrug/1.jpg": 56276,
	"./Smith_Machine_Bench_Press/0.jpg": 58105,
	"./Smith_Machine_Bench_Press/1.jpg": 30108,
	"./Smith_Machine_Bent_Over_Row/0.jpg": 88120,
	"./Smith_Machine_Bent_Over_Row/1.jpg": 32949,
	"./Smith_Machine_Calf_Raise/0.jpg": 33398,
	"./Smith_Machine_Calf_Raise/1.jpg": 96563,
	"./Smith_Machine_Close-Grip_Bench_Press/0.jpg": 76643,
	"./Smith_Machine_Close-Grip_Bench_Press/1.jpg": 38118,
	"./Smith_Machine_Decline_Press/0.jpg": 97217,
	"./Smith_Machine_Decline_Press/1.jpg": 19172,
	"./Smith_Machine_Hang_Power_Clean/0.jpg": 95453,
	"./Smith_Machine_Hang_Power_Clean/1.jpg": 39872,
	"./Smith_Machine_Hip_Raise/0.jpg": 44597,
	"./Smith_Machine_Hip_Raise/1.jpg": 99768,
	"./Smith_Machine_Incline_Bench_Press/0.jpg": 64658,
	"./Smith_Machine_Incline_Bench_Press/1.jpg": 41039,
	"./Smith_Machine_Leg_Press/0.jpg": 31179,
	"./Smith_Machine_Leg_Press/1.jpg": 53134,
	"./Smith_Machine_One-Arm_Upright_Row/0.jpg": 63469,
	"./Smith_Machine_One-Arm_Upright_Row/1.jpg": 36368,
	"./Smith_Machine_Overhead_Shoulder_Press/0.jpg": 43908,
	"./Smith_Machine_Overhead_Shoulder_Press/1.jpg": 21953,
	"./Smith_Machine_Pistol_Squat/0.jpg": 64091,
	"./Smith_Machine_Pistol_Squat/1.jpg": 9310,
	"./Smith_Machine_Reverse_Calf_Raises/0.jpg": 77966,
	"./Smith_Machine_Reverse_Calf_Raises/1.jpg": 57451,
	"./Smith_Machine_Squat/0.jpg": 60185,
	"./Smith_Machine_Squat/1.jpg": 39132,
	"./Smith_Machine_Stiff-Legged_Deadlift/0.jpg": 1956,
	"./Smith_Machine_Stiff-Legged_Deadlift/1.jpg": 80001,
	"./Smith_Machine_Upright_Row/0.jpg": 91629,
	"./Smith_Machine_Upright_Row/1.jpg": 23056,
	"./Smith_Single-Leg_Split_Squat/0.jpg": 31350,
	"./Smith_Single-Leg_Split_Squat/1.jpg": 86611,
	"./Snatch/0.jpg": 31238,
	"./Snatch/1.jpg": 69763,
	"./Snatch_Balance/0.jpg": 43771,
	"./Snatch_Balance/1.jpg": 72638,
	"./Snatch_Deadlift/0.jpg": 89772,
	"./Snatch_Deadlift/1.jpg": 45033,
	"./Snatch_Pull/0.jpg": 12640,
	"./Snatch_Pull/1.jpg": 51869,
	"./Snatch_Shrug/0.jpg": 56426,
	"./Snatch_Shrug/1.jpg": 12263,
	"./Snatch_from_Blocks/0.jpg": 56454,
	"./Snatch_from_Blocks/1.jpg": 94979,
	"./Speed_Band_Overhead_Triceps/0.jpg": 1624,
	"./Speed_Band_Overhead_Triceps/1.jpg": 9493,
	"./Speed_Box_Squat/0.jpg": 99941,
	"./Speed_Box_Squat/1.jpg": 37576,
	"./Speed_Squats/0.jpg": 96894,
	"./Speed_Squats/1.jpg": 51675,
	"./Spell_Caster/0.jpg": 57302,
	"./Spell_Caster/1.jpg": 43763,
	"./Spider_Crawl/0.jpg": 84716,
	"./Spider_Crawl/1.jpg": 22761,
	"./Spider_Curl/0.jpg": 32329,
	"./Spider_Curl/1.jpg": 94284,
	"./Spinal_Stretch/0.jpg": 70966,
	"./Spinal_Stretch/1.jpg": 57427,
	"./Split_Clean/0.jpg": 2763,
	"./Split_Clean/1.jpg": 8366,
	"./Split_Jerk/0.jpg": 66398,
	"./Split_Jerk/1.jpg": 21179,
	"./Split_Jump/0.jpg": 18488,
	"./Split_Jump/1.jpg": 25749,
	"./Split_Snatch/0.jpg": 21105,
	"./Split_Snatch/1.jpg": 42580,
	"./Split_Squat_with_Dumbbells/0.jpg": 35470,
	"./Split_Squat_with_Dumbbells/1.jpg": 13515,
	"./Split_Squats/0.jpg": 88373,
	"./Split_Squats/1.jpg": 27192,
	"./Squat_Jerk/0.jpg": 79348,
	"./Squat_Jerk/1.jpg": 73534,
	"./Squat_with_Bands/0.jpg": 63787,
	"./Squat_with_Bands/1.jpg": 85742,
	"./Squat_with_Chains/0.jpg": 91691,
	"./Squat_with_Chains/1.jpg": 97294,
	"./Squat_with_Plate_Movers/0.jpg": 29124,
	"./Squat_with_Plate_Movers/1.jpg": 7169,
	"./Squats_-_With_Bands/0.jpg": 58824,
	"./Squats_-_With_Bands/1.jpg": 4837,
	"./Stairmaster/0.jpg": 45996,
	"./Stairmaster/1.jpg": 17609,
	"./Standing_Alternating_Dumbbell_Press/0.jpg": 50051,
	"./Standing_Alternating_Dumbbell_Press/1.jpg": 6918,
	"./Standing_Barbell_Calf_Raise/0.jpg": 34026,
	"./Standing_Barbell_Calf_Raise/1.jpg": 1767,
	"./Standing_Barbell_Press_Behind_Neck/0.jpg": 61785,
	"./Standing_Barbell_Press_Behind_Neck/1.jpg": 91260,
	"./Standing_Bent-Over_One-Arm_Dumbbell_Triceps_Extension/0.jpg": 38917,
	"./Standing_Bent-Over_One-Arm_Dumbbell_Triceps_Extension/1.jpg": 76552,
	"./Standing_Bent-Over_Two-Arm_Dumbbell_Triceps_Extension/0.jpg": 86323,
	"./Standing_Bent-Over_Two-Arm_Dumbbell_Triceps_Extension/1.jpg": 14710,
	"./Standing_Biceps_Cable_Curl/0.jpg": 4057,
	"./Standing_Biceps_Cable_Curl/1.jpg": 76060,
	"./Standing_Biceps_Stretch/0.jpg": 51344,
	"./Standing_Biceps_Stretch/1.jpg": 96237,
	"./Standing_Bradford_Press/0.jpg": 77314,
	"./Standing_Bradford_Press/1.jpg": 73631,
	"./Standing_Cable_Chest_Press/0.jpg": 9987,
	"./Standing_Cable_Chest_Press/1.jpg": 66854,
	"./Standing_Cable_Lift/0.jpg": 10827,
	"./Standing_Cable_Lift/1.jpg": 32782,
	"./Standing_Cable_Wood_Chop/0.jpg": 8222,
	"./Standing_Cable_Wood_Chop/1.jpg": 56059,
	"./Standing_Calf_Raises/0.jpg": 18124,
	"./Standing_Calf_Raises/1.jpg": 15913,
	"./Standing_Concentration_Curl/0.jpg": 68126,
	"./Standing_Concentration_Curl/1.jpg": 69435,
	"./Standing_Dumbbell_Calf_Raise/0.jpg": 69891,
	"./Standing_Dumbbell_Calf_Raise/1.jpg": 10406,
	"./Standing_Dumbbell_Press/0.jpg": 13269,
	"./Standing_Dumbbell_Press/1.jpg": 8952,
	"./Standing_Dumbbell_Reverse_Curl/0.jpg": 46351,
	"./Standing_Dumbbell_Reverse_Curl/1.jpg": 90322,
	"./Standing_Dumbbell_Straight-Arm_Front_Delt_Raise_Above_Head/0.jpg": 97865,
	"./Standing_Dumbbell_Straight-Arm_Front_Delt_Raise_Above_Head/1.jpg": 26252,
	"./Standing_Dumbbell_Triceps_Extension/0.jpg": 86894,
	"./Standing_Dumbbell_Triceps_Extension/1.jpg": 64939,
	"./Standing_Dumbbell_Upright_Row/0.jpg": 31894,
	"./Standing_Dumbbell_Upright_Row/1.jpg": 18355,
	"./Standing_Elevated_Quad_Stretch/0.jpg": 55836,
	"./Standing_Elevated_Quad_Stretch/1.jpg": 60537,
	"./Standing_Front_Barbell_Raise_Over_Head/0.jpg": 2797,
	"./Standing_Front_Barbell_Raise_Over_Head/1.jpg": 57904,
	"./Standing_Gastrocnemius_Calf_Stretch/0.jpg": 15495,
	"./Standing_Gastrocnemius_Calf_Stretch/1.jpg": 76490,
	"./Standing_Hamstring_and_Calf_Stretch/0.jpg": 3344,
	"./Standing_Hamstring_and_Calf_Stretch/1.jpg": 48237,
	"./Standing_Hip_Circles/0.jpg": 82779,
	"./Standing_Hip_Circles/1.jpg": 62622,
	"./Standing_Hip_Flexors/0.jpg": 46665,
	"./Standing_Hip_Flexors/1.jpg": 75052,
	"./Standing_Inner-Biceps_Curl/0.jpg": 76748,
	"./Standing_Inner-Biceps_Curl/1.jpg": 22121,
	"./Standing_Lateral_Stretch/0.jpg": 67993,
	"./Standing_Lateral_Stretch/1.jpg": 70620,
	"./Standing_Leg_Curl/0.jpg": 37663,
	"./Standing_Leg_Curl/1.jpg": 45954,
	"./Standing_Long_Jump/0.jpg": 35855,
	"./Standing_Long_Jump/1.jpg": 59474,
	"./Standing_Low-Pulley_Deltoid_Raise/0.jpg": 51277,
	"./Standing_Low-Pulley_Deltoid_Raise/1.jpg": 24176,
	"./Standing_Low-Pulley_One-Arm_Triceps_Extension/0.jpg": 32485,
	"./Standing_Low-Pulley_One-Arm_Triceps_Extension/1.jpg": 88968,
	"./Standing_Military_Press/0.jpg": 37291,
	"./Standing_Military_Press/1.jpg": 57806,
	"./Standing_Olympic_Plate_Hand_Squeeze/0.jpg": 83003,
	"./Standing_Olympic_Plate_Hand_Squeeze/1.jpg": 35166,
	"./Standing_One-Arm_Cable_Curl/0.jpg": 29782,
	"./Standing_One-Arm_Cable_Curl/1.jpg": 92947,
	"./Standing_One-Arm_Dumbbell_Curl_Over_Incline_Bench/0.jpg": 65223,
	"./Standing_One-Arm_Dumbbell_Curl_Over_Incline_Bench/1.jpg": 53066,
	"./Standing_One-Arm_Dumbbell_Triceps_Extension/0.jpg": 96458,
	"./Standing_One-Arm_Dumbbell_Triceps_Extension/1.jpg": 64199,
	"./Standing_Overhead_Barbell_Triceps_Extension/0.jpg": 14248,
	"./Standing_Overhead_Barbell_Triceps_Extension/1.jpg": 58213,
	"./Standing_Palm-In_One-Arm_Dumbbell_Press/0.jpg": 45774,
	"./Standing_Palm-In_One-Arm_Dumbbell_Press/1.jpg": 40171,
	"./Standing_Palms-In_Dumbbell_Press/0.jpg": 32057,
	"./Standing_Palms-In_Dumbbell_Press/1.jpg": 11004,
	"./Standing_Palms-Up_Barbell_Behind_The_Back_Wrist_Curl/0.jpg": 60780,
	"./Standing_Palms-Up_Barbell_Behind_The_Back_Wrist_Curl/1.jpg": 98825,
	"./Standing_Pelvic_Tilt/0.jpg": 82377,
	"./Standing_Pelvic_Tilt/1.jpg": 10764,
	"./Standing_Rope_Crunch/0.jpg": 48426,
	"./Standing_Rope_Crunch/1.jpg": 16167,
	"./Standing_Soleus_And_Achilles_Stretch/0.jpg": 73001,
	"./Standing_Soleus_And_Achilles_Stretch/1.jpg": 1388,
	"./Standing_Toe_Touches/0.jpg": 66958,
	"./Standing_Toe_Touches/1.jpg": 61355,
	"./Standing_Towel_Triceps_Extension/0.jpg": 17192,
	"./Standing_Towel_Triceps_Extension/1.jpg": 60709,
	"./Standing_Two-Arm_Overhead_Throw/0.jpg": 86673,
	"./Standing_Two-Arm_Overhead_Throw/1.jpg": 14868,
	"./Star_Jump/0.jpg": 2118,
	"./Star_Jump/1.jpg": 40643,
	"./Step-up_with_Knee_Raise/0.jpg": 42399,
	"./Step-up_with_Knee_Raise/1.jpg": 22402,
	"./Step_Mill/0.jpg": 18294,
	"./Step_Mill/1.jpg": 4755,
	"./Stiff-Legged_Barbell_Deadlift/0.jpg": 9761,
	"./Stiff-Legged_Barbell_Deadlift/1.jpg": 19812,
	"./Stiff-Legged_Dumbbell_Deadlift/0.jpg": 37246,
	"./Stiff-Legged_Dumbbell_Deadlift/1.jpg": 57403,
	"./Stiff_Leg_Barbell_Good_Morning/0.jpg": 38336,
	"./Stiff_Leg_Barbell_Good_Morning/1.jpg": 47549,
	"./Stomach_Vacuum/0.jpg": 34556,
	"./Stomach_Vacuum/1.jpg": 31929,
	"./Straight-Arm_Dumbbell_Pullover/0.jpg": 18308,
	"./Straight-Arm_Dumbbell_Pullover/1.jpg": 96353,
	"./Straight-Arm_Pulldown/0.jpg": 88570,
	"./Straight-Arm_Pulldown/1.jpg": 52407,
	"./Straight_Bar_Bench_Mid_Rows/0.jpg": 78177,
	"./Straight_Bar_Bench_Mid_Rows/1.jpg": 132,
	"./Straight_Raises_on_Incline_Bench/0.jpg": 9529,
	"./Straight_Raises_on_Incline_Bench/1.jpg": 39004,
	"./Stride_Jump_Crossover/0.jpg": 97344,
	"./Stride_Jump_Crossover/1.jpg": 48477,
	"./Sumo_Deadlift/0.jpg": 78823,
	"./Sumo_Deadlift/1.jpg": 6634,
	"./Sumo_Deadlift_with_Bands/0.jpg": 9431,
	"./Sumo_Deadlift_with_Bands/1.jpg": 41146,
	"./Sumo_Deadlift_with_Chains/0.jpg": 99927,
	"./Sumo_Deadlift_with_Chains/1.jpg": 12410,
	"./Superman/0.jpg": 71400,
	"./Superman/1.jpg": 33765,
	"./Supine_Chest_Throw/0.jpg": 33174,
	"./Supine_Chest_Throw/1.jpg": 88435,
	"./Supine_One-Arm_Overhead_Throw/0.jpg": 92181,
	"./Supine_One-Arm_Overhead_Throw/1.jpg": 47352,
	"./Supine_Two-Arm_Overhead_Throw/0.jpg": 45479,
	"./Supine_Two-Arm_Overhead_Throw/1.jpg": 49674,
	"./Suspended_Fallout/0.jpg": 77142,
	"./Suspended_Fallout/1.jpg": 40307,
	"./Suspended_Push-Up/0.jpg": 58813,
	"./Suspended_Push-Up/1.jpg": 90720,
	"./Suspended_Reverse_Crunch/0.jpg": 9991,
	"./Suspended_Reverse_Crunch/1.jpg": 42250,
	"./Suspended_Row/0.jpg": 17791,
	"./Suspended_Row/1.jpg": 26082,
	"./Suspended_Split_Squat/0.jpg": 30684,
	"./Suspended_Split_Squat/1.jpg": 28057,
	"./Svend_Press/0.jpg": 94835,
	"./Svend_Press/1.jpg": 23222,
	"./T-Bar_Row_with_Handle/0.jpg": 18020,
	"./T-Bar_Row_with_Handle/1.jpg": 96065,
	"./Tate_Press/0.jpg": 31163,
	"./Tate_Press/1.jpg": 29854,
	"./The_Straddle/0.jpg": 48500,
	"./The_Straddle/1.jpg": 62225,
	"./Thigh_Abductor/0.jpg": 38286,
	"./Thigh_Abductor/1.jpg": 16331,
	"./Thigh_Adductor/0.jpg": 8084,
	"./Thigh_Adductor/1.jpg": 79889,
	"./Tire_Flip/0.jpg": 24277,
	"./Tire_Flip/1.jpg": 16408,
	"./Toe_Touchers/0.jpg": 48395,
	"./Toe_Touchers/1.jpg": 70350,
	"./Torso_Rotation/0.jpg": 98189,
	"./Torso_Rotation/1.jpg": 29616,
	"./Trail_Running_Walking/0.jpg": 44365,
	"./Trail_Running_Walking/1.jpg": 75792,
	"./Trap_Bar_Deadlift/0.jpg": 91790,
	"./Trap_Bar_Deadlift/1.jpg": 69835,
	"./Tricep_Dumbbell_Kickback/0.jpg": 91642,
	"./Tricep_Dumbbell_Kickback/1.jpg": 59927,
	"./Tricep_Side_Stretch/0.jpg": 84010,
	"./Tricep_Side_Stretch/1.jpg": 79815,
	"./Triceps_Overhead_Extension_with_Rope/0.jpg": 9996,
	"./Triceps_Overhead_Extension_with_Rope/1.jpg": 7785,
	"./Triceps_Pushdown/0.jpg": 63968,
	"./Triceps_Pushdown/1.jpg": 89533,
	"./Triceps_Pushdown_-_Rope_Attachment/0.jpg": 82105,
	"./Triceps_Pushdown_-_Rope_Attachment/1.jpg": 61052,
	"./Triceps_Pushdown_-_V-Bar_Attachment/0.jpg": 32613,
	"./Triceps_Pushdown_-_V-Bar_Attachment/1.jpg": 88648,
	"./Triceps_Stretch/0.jpg": 73883,
	"./Triceps_Stretch/1.jpg": 88926,
	"./Tuck_Crunch/0.jpg": 32700,
	"./Tuck_Crunch/1.jpg": 53753,
	"./Two-Arm_Dumbbell_Preacher_Curl/0.jpg": 76042,
	"./Two-Arm_Dumbbell_Preacher_Curl/1.jpg": 15047,
	"./Two-Arm_Kettlebell_Clean/0.jpg": 26237,
	"./Two-Arm_Kettlebell_Clean/1.jpg": 58144,
	"./Two-Arm_Kettlebell_Jerk/0.jpg": 92904,
	"./Two-Arm_Kettlebell_Jerk/1.jpg": 36421,
	"./Two-Arm_Kettlebell_Military_Press/0.jpg": 28267,
	"./Two-Arm_Kettlebell_Military_Press/1.jpg": 32430,
	"./Two-Arm_Kettlebell_Row/0.jpg": 29410,
	"./Two-Arm_Kettlebell_Row/1.jpg": 21119,
	"./Underhand_Cable_Pulldowns/0.jpg": 32163,
	"./Underhand_Cable_Pulldowns/1.jpg": 58406,
	"./Upper_Back-Leg_Grab/0.jpg": 65999,
	"./Upper_Back-Leg_Grab/1.jpg": 89618,
	"./Upper_Back_Stretch/0.jpg": 67871,
	"./Upper_Back_Stretch/1.jpg": 55202,
	"./Upright_Barbell_Row/0.jpg": 61554,
	"./Upright_Barbell_Row/1.jpg": 37935,
	"./Upright_Cable_Row/0.jpg": 64301,
	"./Upright_Cable_Row/1.jpg": 19408,
	"./Upright_Row_-_With_Bands/0.jpg": 60627,
	"./Upright_Row_-_With_Bands/1.jpg": 97462,
	"./Upward_Stretch/0.jpg": 45944,
	"./Upward_Stretch/1.jpg": 7125,
	"./V-Bar_Pulldown/0.jpg": 58543,
	"./V-Bar_Pulldown/1.jpg": 90610,
	"./V-Bar_Pullup/0.jpg": 86728,
	"./V-Bar_Pullup/1.jpg": 30693,
	"./Vertical_Swing/0.jpg": 28010,
	"./Vertical_Swing/1.jpg": 83847,
	"./Walking_Treadmill/0.jpg": 16035,
	"./Walking_Treadmill/1.jpg": 25926,
	"./Weighted_Ball_Hyperextension/0.jpg": 82986,
	"./Weighted_Ball_Hyperextension/1.jpg": 21991,
	"./Weighted_Ball_Side_Bend/0.jpg": 4352,
	"./Weighted_Ball_Side_Bend/1.jpg": 43581,
	"./Weighted_Bench_Dip/0.jpg": 54597,
	"./Weighted_Bench_Dip/1.jpg": 26984,
	"./Weighted_Crunches/0.jpg": 35524,
	"./Weighted_Crunches/1.jpg": 13569,
	"./Weighted_Jump_Squat/0.jpg": 83488,
	"./Weighted_Jump_Squat/1.jpg": 34621,
	"./Weighted_Pull_Ups/0.jpg": 23517,
	"./Weighted_Pull_Ups/1.jpg": 84288,
	"./Weighted_Sissy_Squat/0.jpg": 4809,
	"./Weighted_Sissy_Squat/1.jpg": 66764,
	"./Weighted_Sit-Ups_-_With_Bands/0.jpg": 14234,
	"./Weighted_Sit-Ups_-_With_Bands/1.jpg": 66167,
	"./Weighted_Squat/0.jpg": 72643,
	"./Weighted_Squat/1.jpg": 29510,
	"./Wide-Grip_Barbell_Bench_Press/0.jpg": 68853,
	"./Wide-Grip_Barbell_Bench_Press/1.jpg": 60984,
	"./Wide-Grip_Decline_Barbell_Bench_Press/0.jpg": 51306,
	"./Wide-Grip_Decline_Barbell_Bench_Press/1.jpg": 73959,
	"./Wide-Grip_Decline_Barbell_Pullover/0.jpg": 23523,
	"./Wide-Grip_Decline_Barbell_Pullover/1.jpg": 84998,
	"./Wide-Grip_Lat_Pulldown/0.jpg": 10853,
	"./Wide-Grip_Lat_Pulldown/1.jpg": 83240,
	"./Wide-Grip_Pulldown_Behind_The_Neck/0.jpg": 97152,
	"./Wide-Grip_Pulldown_Behind_The_Neck/1.jpg": 22717,
	"./Wide-Grip_Rear_Pull-Up/0.jpg": 90248,
	"./Wide-Grip_Rear_Pull-Up/1.jpg": 17861,
	"./Wide-Grip_Standing_Barbell_Curl/0.jpg": 1044,
	"./Wide-Grip_Standing_Barbell_Curl/1.jpg": 98417,
	"./Wide_Stance_Barbell_Squat/0.jpg": 44503,
	"./Wide_Stance_Barbell_Squat/1.jpg": 73338,
	"./Wide_Stance_Stiff_Legs/0.jpg": 97814,
	"./Wide_Stance_Stiff_Legs/1.jpg": 84275,
	"./Wind_Sprints/0.jpg": 20667,
	"./Wind_Sprints/1.jpg": 84158,
	"./Windmills/0.jpg": 61706,
	"./Windmills/1.jpg": 73863,
	"./Worlds_Greatest_Stretch/0.jpg": 28784,
	"./Worlds_Greatest_Stretch/1.jpg": 72237,
	"./Wrist_Circles/0.jpg": 40554,
	"./Wrist_Circles/1.jpg": 52711,
	"./Wrist_Roller/0.jpg": 1671,
	"./Wrist_Roller/1.jpg": 45834,
	"./Wrist_Rotations_with_Straight_Bar/0.jpg": 5942,
	"./Wrist_Rotations_with_Straight_Bar/1.jpg": 34355,
	"./Yoke_Walk/0.jpg": 80913,
	"./Yoke_Walk/1.jpg": 66580,
	"./Zercher_Squats/0.jpg": 24772,
	"./Zercher_Squats/1.jpg": 2817,
	"./Zottman_Curl/0.jpg": 39895,
	"./Zottman_Curl/1.jpg": 76058,
	"./Zottman_Preacher_Curl/0.jpg": 4046,
	"./Zottman_Preacher_Curl/1.jpg": 30507,
	"./exercises": 79430,
	"./exercises.json": 79430
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10264;